/* multicart-restore-20261027 */
(function () {
  "use strict";
  // --- 2Day: customer ORIGINAL file upload (added 2026-10-21) ---
  // Sends the untouched File (kind:"original") alongside the normal shrunk preview/print flow.
  // App proxy first, then the VPS directly. Never throws: failures resolve "" and only log a warning.
  var __2D_ORIG_PROXY = "/apps/artwork-upload/upload";
  var __2D_ORIG_DIRECT = "https://files.3agraphics.ca/upload";
  var __2D_ORIG_MAX = 30 * 1024 * 1024;
  var __2dOrigCache = typeof WeakMap === "function" ? new WeakMap() : null;
  function __2dOrigPost(url, body, secret) {
    return fetch(url, {
      method: "POST",
      credentials: url.charAt(0) === "/" ? "same-origin" : "omit",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-2Day-Secret": secret },
      body: body
    }).then(function (res) {
      return res.text().then(function (t) {
        var d = null;
        try { d = JSON.parse(t); } catch (e) { d = null; }
        if (res.ok && d && d.ok && d.url) return String(d.url);
        var err = new Error((d && d.error) || "HTTP " + res.status);
        err.fatal = !!(d && (res.status === 400 || res.status === 401 || res.status === 413));
        throw err;
      });
    });
  }
  function __2dUploadOriginal(file, secret) {
    if (!file || !secret || typeof FileReader === "undefined") return Promise.resolve("");
    if (__2dOrigCache && __2dOrigCache.has(file)) return __2dOrigCache.get(file);
    var p = new Promise(function (resolve) {
      if (file.size > __2D_ORIG_MAX) { console.warn("[2Day] original file is over 30 MB, not uploaded:", file.name); resolve(""); return; }
      var fr = new FileReader();
      fr.onerror = function () { console.warn("[2Day] could not read the original file:", file.name); resolve(""); };
      fr.onload = function () {
        var body = JSON.stringify({ kind: "original", fileName: file.name, fileBase64: String(fr.result || ""), secret: secret });
        __2dOrigPost(__2D_ORIG_PROXY, body, secret)
          .catch(function (e) {
            if (e && e.fatal) throw e;
            console.warn("[2Day] original upload via app proxy failed, trying direct:", e && e.message);
            return __2dOrigPost(__2D_ORIG_DIRECT, body, secret);
          })
          .then(resolve, function (e) { console.warn("[2Day] original upload failed (cart not affected):", e && e.message); resolve(""); });
      };
      fr.readAsDataURL(file);
    });
    if (__2dOrigCache) {
      __2dOrigCache.set(file, p);
      p.then(function (u) { if (!u) __2dOrigCache.delete(file); });
    }
    return p;
  }
  // Resolves to one URL per file ("" when missing/failed/slower than ms) — never rejects.
  function __2dOriginalsWithin(files, secret, ms) {
    return Promise.all((files || []).map(function (f) {
      if (!f) return "";
      return Promise.race([
        __2dUploadOriginal(f, secret),
        new Promise(function (r) { setTimeout(function () { r(""); }, ms || 45000); })
      ]);
    })).catch(function () { return []; });
  }
  // --- 2Day: API error text + one retry on tunnel 404/5xx (added 2026-10-14) ---
  function __2dErrText(x, fb) {
    if (!x) return fb || "";
    if (typeof x === "string") return /failed to fetch|networkerror|load failed|^<|bad gateway|gateway time/i.test(x) ? "Our pricing server is reconnecting. Please try again in a few seconds." : x;
    if (x.error && x.error !== x) {
      var code = (x.error && x.error.code) || "";
      if (/TUNNEL/i.test(code)) return "Our pricing server is reconnecting. Please try again in a few seconds.";
      return __2dErrText(x.error, fb);
    }
    if (/TUNNEL/i.test(x.code || "")) return "Our pricing server is reconnecting. Please try again in a few seconds.";
    if (typeof x.message === "string" && x.message) return /failed to fetch|networkerror|load failed/i.test(x.message) ? "Our pricing server is reconnecting. Please try again in a few seconds." : x.message;
    if (typeof x.description === "string" && x.description) return x.description;
    return fb || "Something went wrong. Please try again.";
  }
  function __2dApiFetch(url, opts) {
    return fetch(url, opts).then(function (res) {
      if (res.status === 404 || res.status >= 500) {
        return new Promise(function (r) { setTimeout(r, 1500); }).then(function () { return fetch(url, opts); });
      }
      return res;
    }, function () {
      return new Promise(function (r) { setTimeout(r, 1500); }).then(function () { return fetch(url, opts); });
    });
  }

  // contour-cut v1 · decals v1

  var MAX_FILE_SIZE = 50 * 1024 * 1024;
  var ALLOWED_EXTENSIONS = ["png", "jpg", "jpeg", "webp", "pdf", "ai", "eps"];
  var SIZE_PRESETS = [
    [1, 1],
    [2, 2],
    [3, 2],
    [3, 3],
    [4, 3],
    [4, 4]
  ];

  // Penny test orders: exactly 1 label = $0.01 CAD (API marks it tax-exempt / no shipping).
  var PENNY_TEST_QTY = 1;
  // 2026-10-09: smallest orderable quantity (the typed qty-1 $0.01 test stays allowed) and the quantity preselected for new quotes
  var MIN_ORDER_QTY = 500; // was 250 until 2026-10-26
  var DEFAULT_QTY = 5000;
  function minQty(n) { n = Math.floor(Number(n) || 0); return n === PENNY_TEST_QTY ? n : Math.max(MIN_ORDER_QTY, n); }
  var PENNY_TEST_PRICE = 0.01;

  // Label types offered in the builder (Round/Rectangle/Square/Oval were removed 2026-09-24;
  // saved quotes and per-type pages that still name them fall back to Die-cut).
  // 2026-10-05 (Tony): the builder offers only Rolls and Sheets (segmented buttons); every other / legacy type falls back to Rolls.
  var FORMATS = ["Roll labels", "Label sheets"];
  var MATERIALS = ["Matte", "Glossy", "Silver foil", "Gold foil", "Raised UV", "Freezer grade", "Clear"];
  // Customer-facing material names. Internal keys stay Matte/Glossy for pricing.
  // "Matte" meant white face stock, not a matte finish — that collided with Lamination: Gloss/Matte (2026-10-27).
  var MATERIAL_LABELS = {
    "Matte": "White BOPP",
    "Glossy": "Glossy BOPP",
    "Silver foil": "Silver foil",
    "Gold foil": "Gold foil",
    "Raised UV": "Raised UV",
    "Freezer grade": "Freezer grade",
    "Clear": "Clear"
  };
  function materialLabel(m) {
    return MATERIAL_LABELS[m] || m || "White BOPP";
  }
  // Face-stock finishes that look like a "finish" next to lamination — omit from title chips when laminated.
  var FACE_STOCK_MATERIALS = ["Matte", "Glossy"];
  function materialChip(m, laminated) {
    if (laminated && FACE_STOCK_MATERIALS.indexOf(m) !== -1) return null;
    return materialLabel(m);
  }
  // Die-cut hold (2026-10-05): <html class="diecut-off"> (theme.liquid, shop metafield custom.diecut_enabled / GET /apps/artwork-upload/flags)
  // pauses ONLY the custom-shape "Die-cut labels" type. Pages / saved quotes / deep links that name it (or a removed shape type) fall back to Roll labels
  // (their circle / square / rectangle / oval shape is kept via the roll-shape preset).
  function diecutOff() { return document.documentElement.classList.contains("diecut-off"); }
  // contour-cut v1 (2026-10-06): third label type "Contour cut" (button "Custom shape"), offered only while <html class="contour-on">
  // (snippets/contour-flag.liquid: shop metafield custom.contour_enabled or a valid ?contour_preview token). Size = the cut line's
  // bounding box (aspect locked to the artwork); priced exactly like Roll labels on that box (server: quote-pricing.mjs / contour-api.mjs).
  var CONTOUR_FORMAT = "Contour cut";
  var CONTOUR_MIN_IN = 1;
  function contourOn() { return document.documentElement.classList.contains("contour-on"); }
  function normalizeFormat(f) {
    if (f === "Contour cut") return contourOn() ? f : "Roll labels";
    return FORMATS.indexOf(f) !== -1 ? f : "Roll labels";
  }

  // Specialty finishes (gold/silver foil, raised UV) can be paused store-wide: <html class="specialty-off"> (theme.liquid, from the shop metafield / GET /apps/artwork-upload/flags).
  var SPECIALTY_MATERIALS = ["Silver foil", "Gold foil", "Raised UV"];
  function specialtyOff() { return document.documentElement.classList.contains("specialty-off"); }
  function normalizeMaterial(m) {
    if (specialtyOff() && SPECIALTY_MATERIALS.indexOf(m) !== -1) return "Matte";
    return MATERIALS.indexOf(m) !== -1 ? m : "Matte";
  }

  // Instant on-screen ESTIMATE only. The charged price is computed by the upload API
  // (quote-pricing.mjs, same formula) from the selections; the browser price is never trusted.
  // BEGIN PRICING (sinalite110+curve) — identical in theme assets/quote-builder.js and stable/quote-pricing.mjs
  // 2026-10-01: 2Day base price = SinaLite BOPP LIST price (CAD, pulled 2026-09-26) x 1.10, any size / quantity.
  // list(w,h,q) = SETUP + V(effLen(w,h), q): SETUP = fixed per-job part of SinaLite's list price; V = variable part,
  // a table of SinaLite's (list - SETUP) by material length per label (effLen, in) and quantity, smoothed so that the
  // total never decreases with quantity and $/label never increases (log-log interpolation between table points).
  var SL_UPLIFT = 1.1;
  // Lamination (gloss / matte film over the print, 2026-10-09): + $/MSI of label face area. Default when the published curve has no laminationPerMsi.
  var LAM_PER_MSI_DEFAULT = 0.5;
  // Starter Pack (2026-10-09): exactly 100 labels for a flat $39 (any size / material / format); lamination still adds its $/MSI on top.
  var STARTER_PACK_QTY = 100;
  var STARTER_PACK_PRICE = 39; // was 65 until 2026-10-11
  // Sticker promo (2026-10-09): exactly 50 stickers for a flat $19 (any size / material / format); lamination still adds its $/MSI on top.
  var STICKER_PROMO_QTY = 50;
  var STICKER_PROMO_PRICE = 19;
  var SL_SETUP = 155.5;
  var SL_WEB = 12.0;
  var SL_GAP = 0.125;
  var SL_Q = [25,50,100,250,500,1000,2000,2500,3000,3500,4000,4500,5000,10000,15000,20000,30000,35000,40000,45000,50000,55000,60000,65000,70000,75000,80000,85000,90000,95000,100000];
  var SL_K = [2.55,5.1,7.5,12.5,18.75,24.75,30.75,36.75,73.5,85.5,97.5,109.5,121.5,133.5,145.5];
  var SL_LNV = [
    [-0.61619,-0.23572,0.25464,1.02245,1.64673,2.29051,2.91885,3.11751,3.26881,3.39618,3.50526,3.60032,3.66817,4.62889,5.01463,5.34744,5.72509,5.90244,6.04118,6.1761,6.27863,6.38863,6.47426,6.56114,6.63944,6.71054,6.77548,6.84649,7.01905,7.06019,7.10794],
    [-0.13926,0.36464,0.94779,1.79176,2.44842,3.10906,3.75677,3.96329,4.1205,4.25078,4.36767,4.46303,4.54606,5.35337,5.72509,6.04118,6.40841,6.5682,6.71054,6.83106,7.04992,7.1412,7.2221,7.29439,7.36498,7.42943,7.4773,7.52604,7.56474,7.61134,7.64874],
    [-0.07257,0.65233,1.35325,2.21812,2.88815,3.55649,4.20604,4.41122,4.57358,4.70872,4.81972,4.91918,5.00207,5.77297,6.14034,6.44287,6.80643,7.07407,7.19804,7.31,7.3877,7.46052,7.52299,7.58911,7.64813,7.70105,7.75291,7.80017,7.84774,7.89619,7.94151],
    [0.41211,1.10526,1.82294,2.74148,3.42719,4.10611,4.76363,4.97002,5.13214,5.26873,5.38486,5.48293,5.56842,6.30644,6.67088,7.07883,7.38382,7.49729,7.60482,7.69594,7.77996,7.85748,7.93346,7.99883,8.06295,8.12414,8.18039,8.23232,8.28327,8.3337,8.37827],
    [0.73237,1.4816,2.2192,3.157,3.85015,4.53131,5.19307,5.39965,5.5646,5.70008,5.81491,5.91537,6.00171,6.72417,7.18579,7.40384,7.66999,7.79734,7.91351,8.01364,8.1073,8.18982,8.267,8.34239,8.40747,8.4729,8.53161,8.58612,8.64091,8.69044,8.73904],
    [1.06815,1.79176,2.5177,3.4484,4.13964,4.81972,5.4811,5.68765,5.85263,5.98843,6.10464,6.20381,6.29031,7.11814,7.37797,7.60606,7.89222,8.02354,8.1447,8.2485,8.34611,8.43285,8.51368,8.58857,8.65715,8.72337,8.78337,8.84079,8.89457,8.94667,8.99432],
    [1.31641,2.02815,2.74791,3.67529,4.36526,5.04491,5.70615,5.91266,6.07773,6.21463,6.32992,6.42924,6.51588,7.31126,7.56474,7.79193,8.09018,8.22447,8.3467,8.45548,8.5497,8.63925,8.72123,8.79586,8.86548,8.93222,8.99183,9.04985,9.10553,9.15549,9.20635],
    [1.51951,2.2192,2.93439,3.85883,4.54807,5.22725,5.88832,6.09481,6.25991,6.3968,6.51216,6.61231,6.69903,7.37209,7.65587,7.90616,8.21959,8.36247,8.48823,8.60027,8.70019,8.78949,8.87323,8.95073,9.02206,9.08913,9.15052,9.20892,9.26481,9.31752,9.36844],
    [2.20607,2.93306,3.64192,4.56383,5.25246,5.93112,6.59252,6.79913,6.95842,7.17003,7.24575,7.31318,7.37365,7.95499,8.26845,8.53677,8.87033,9.01941,9.14732,9.26214,9.36523,9.45773,9.54306,9.621,9.69395,9.76196,9.82489,9.88493,9.94144,9.99455,10.0454],
    [2.36837,3.09104,3.79706,4.71716,5.4056,6.08402,6.74531,6.95188,7.18693,7.27749,7.35766,7.42854,7.49172,8.08634,8.40845,8.67826,9.01615,9.16523,9.29483,9.40867,9.5116,9.60518,9.69074,9.7692,9.84255,9.91069,9.97385,10.0335,10.0901,10.1431,10.1942],
    [2.50879,3.22724,3.93173,4.85082,5.53859,6.21713,6.87832,7.18221,7.29033,7.38434,7.46676,7.53974,7.61195,8.21027,8.53438,8.8052,9.14378,9.29448,9.42415,9.53867,9.6417,9.73529,9.82062,9.89927,9.97292,10.0405,10.1043,10.164,10.2205,10.2741,10.3246],
    [2.63189,3.34709,4.04987,4.96828,5.65575,6.33415,6.99524,7.26176,7.37445,7.47194,7.55732,7.63956,7.70613,8.3135,8.64323,8.91513,9.25624,9.40604,9.53685,9.6519,9.75536,9.84931,9.9341,10.0136,10.0864,10.1551,10.2186,10.2788,10.3351,10.3887,10.4396],
    [2.74084,3.45411,4.15575,5.07355,5.76082,6.43908,7.2042,7.34071,7.45648,7.5565,7.65112,7.7272,7.79528,8.41193,8.74304,9.01584,9.35845,9.50836,9.6391,9.75442,9.85773,9.95182,10.0378,10.1164,10.1896,10.258,10.3216,10.3815,10.4383,10.4916,10.5425],
    [2.83908,3.55048,4.25149,5.16861,5.85587,6.53405,7.29863,7.48542,7.63612,7.7338,7.81342,7.88362,7.94683,8.53678,8.85758,9.12657,9.4635,9.61236,9.74162,9.85629,9.95922,10.0522,10.1374,10.2162,10.2889,10.3567,10.4204,10.4801,10.5366,10.5897,10.6403],
    [2.92959,3.6389,4.33886,5.25557,5.94251,6.62078,7.37711,7.56539,7.69645,7.79644,7.87847,7.95055,8.01984,8.61491,8.93791,9.20785,9.54655,9.69557,9.82544,9.93982,10.0435,10.1364,10.222,10.3003,10.3734,10.4416,10.5051,10.5649,10.6212,10.6752,10.7255]
  ];
  // roll length one label consumes (in): labels laid across a 12 in web with a 1/8 in gap, best orientation (smoothed at the whole-label-count steps)
  function slEffLen(w, h) {
    var best = Infinity, i, a, b, n, x;
    for (i = 0; i < 2; i++) {
      a = i ? h : w; b = i ? w : h;
      x = (SL_WEB + SL_GAP) / (a + SL_GAP);
      n = Math.floor(x + 1e-9);
      // labels across the web; just above a whole number the count ramps down over 0.15 so the price has no cliff
      if (n >= 2 && x - n < 0.15) n = n - 1 + Math.max(0, x - n) / 0.15;
      best = Math.min(best, n >= 1 ? SL_WEB * (b + SL_GAP) / n : a * (b + SL_GAP));
    }
    return best;
  }
  function slSeg(arr, x) { // index i with arr[i] <= x <= arr[i+1] (clamped) and fraction t (x in log space already)
    var i = 0;
    while (i < arr.length - 2 && x > arr[i + 1]) i++;
    return i;
  }
  // SinaLite variable cost (CAD) for q labels of effective length eff
  function slVariable(eff, q) {
    var lq = Math.log(Math.max(q, 1)), lk = Math.log(eff), nq = SL_Q.length, nk = SL_K.length;
    var lQ = [], lK = [], i, j;
    for (i = 0; i < nq; i++) lQ.push(Math.log(SL_Q[i]));
    for (j = 0; j < nk; j++) lK.push(Math.log(SL_K[j]));
    function atK(row) { // ln V of one table row at lq (below the first qty: proportional to qty; above the last: marginal $/label of the last step)
      if (lq <= lQ[0]) return row[0] + (lq - lQ[0]);
      if (lq >= lQ[nq - 1]) {
        var vLast = Math.exp(row[nq - 1]), vPrev = Math.exp(row[nq - 2]);
        return Math.log(vLast + (vLast - vPrev) / (SL_Q[nq - 1] - SL_Q[nq - 2]) * (q - SL_Q[nq - 1]));
      }
      var a = slSeg(lQ, lq), t = (lq - lQ[a]) / (lQ[a + 1] - lQ[a]);
      return row[a] + t * (row[a + 1] - row[a]);
    }
    var lv;
    if (lk <= lK[0]) lv = atK(SL_LNV[0]) + 0.9 * (lk - lK[0]); // smaller than the smallest listed label (1 x 2 in): ~proportional to material (data exponent 0.9-1)
    else if (lk >= lK[nk - 1]) lv = atK(SL_LNV[nk - 1]) + (lk - lK[nk - 1]); // larger than the largest listed label (12 x 12): proportional to material
    else {
      j = slSeg(lK, lk);
      var u = (lk - lK[j]) / (lK[j + 1] - lK[j]);
      var v0 = atK(SL_LNV[j]);
      lv = v0 + u * (atK(SL_LNV[j + 1]) - v0);
    }
    return Math.exp(lv);
  }
  // ---- editable price curve (see /workspace/pricing-editor/README.md) ----
  // cfg = { minOrder, setupFee:{enabled,amount}, points:[{msi, rate}] }.  rate = all-in $/MSI of a 2x2 in matte die-cut order,
  // MSI = width x height x qty / 1000.  Between control points kappa is a monotone cubic (PCHIP) on log MSI vs log kappa.  Every other size / format / material
  // keeps the built-in size shape and is multiplied by kappa = curve(MSI) / built-in 2x2 price(MSI)  (kappa = 1 means "unchanged").
  var CV = null; // prepared published curve (null = built-in formula)
  function setCurveConfig(cfg) { CV = cfg ? cvPrep(cfg) : null; return !!CV; }
  function cvRound(v, d) { var m = Math.pow(10, d); return Math.round(v * m) / m; }
  function normalizeCurveConfig(c) {
    if (!c || typeof c !== "object") throw new Error("Curve settings are missing.");
    var pts = c.points;
    if (!Array.isArray(pts) || pts.length < 2) throw new Error("The curve needs at least 2 points.");
    if (pts.length > 80) throw new Error("Too many points (max 80).");
    var out = [], i, m, r, p;
    for (i = 0; i < pts.length; i++) {
      p = pts[i] || {};
      m = Number(p.msi);
      r = p.rate !== undefined && p.rate !== null && p.rate !== "" ? Number(p.rate) : Number(p.total) / m;
      if (!(m >= 0.01 && m <= 40000)) throw new Error("Point " + (i + 1) + ": MSI must be between 0.01 and 40,000.");
      if (!(r > 0 && r <= 1000000)) throw new Error("Point " + (i + 1) + ": $/MSI must be a positive number.");
      out.push({ msi: cvRound(m, 6), rate: cvRound(r, 4) });
    }
    out.sort(function (a, b) { return a.msi - b.msi; });
    for (i = 1; i < out.length; i++) if (!(out[i].msi / out[i - 1].msi > 1.0001)) throw new Error("Two points have (almost) the same MSI: " + out[i].msi + ".");
    var mo = c.minOrder === undefined || c.minOrder === null || c.minOrder === "" ? 50 : Number(c.minOrder);
    if (!(mo >= 0 && mo <= 100000)) throw new Error("Minimum order must be between 0 and 100,000.");
    var sf = c.setupFee, en = false, amt = 0;
    if (sf && typeof sf === "object") { en = !!sf.enabled; amt = Number(sf.amount) || 0; } else if (sf !== undefined && sf !== null) { amt = Number(sf) || 0; en = amt > 0; }
    if (!(amt >= 0 && amt <= 100000)) throw new Error("Setup fee must be between 0 and 100,000.");
    var lam = c.laminationPerMsi === undefined || c.laminationPerMsi === null || c.laminationPerMsi === "" ? LAM_PER_MSI_DEFAULT : Number(c.laminationPerMsi);
    if (!(lam >= 0 && lam <= 100)) throw new Error("Lamination $/MSI must be between 0 and 100.");
    return { minOrder: cvRound(mo, 2), setupFee: { enabled: en, amount: cvRound(amt, 2) }, points: out, laminationPerMsi: cvRound(lam, 4) };
  }
  function cvEnd(h0, h1, d0, d1) {
    var v = ((2 * h0 + h1) * d0 - h0 * d1) / (h0 + h1);
    if (v * d0 <= 0) v = 0;
    else if (d0 * d1 <= 0 && Math.abs(v) > 3 * Math.abs(d0)) v = 3 * d0;
    return v;
  }
  // built-in (pre-curve) price of a 2x2 matte die-cut order of this many MSI, before format / material rates
  function cvRef(msi) { return (SL_SETUP + slVariable(slEffLen(2, 2), (msi * 1000) / 4)) * SL_UPLIFT; }
  // Prepares the curve: at every control point kappa = (curve total + setup fee) / built-in 2x2 price; between points log(kappa) is a
  // monotone cubic (PCHIP) of log(MSI). So an untouched curve gives kappa = 1 (prices unchanged) and a 2x2 matte order is charged exactly
  // the curve at every control point; other sizes / formats / materials are scaled by the same kappa.
  function cvPrep(cfg) {
    var c;
    try { c = normalizeCurveConfig(cfg); } catch (e) { return null; }
    var n = c.points.length, x = [], y = [], h = [], d = [], s = [], i, setup = c.setupFee.enabled ? c.setupFee.amount : 0, ref;
    for (i = 0; i < n; i++) {
      ref = cvRef(c.points[i].msi);
      x.push(Math.log(c.points[i].msi));
      y.push(Math.log((c.points[i].msi * c.points[i].rate + setup) / ref));
    }
    for (i = 0; i < n - 1; i++) { h.push(x[i + 1] - x[i]); d.push((y[i + 1] - y[i]) / h[i]); }
    if (n === 2) { s = [d[0], d[0]]; }
    else {
      for (i = 1; i < n - 1; i++) {
        if (d[i - 1] * d[i] <= 0) s[i] = 0;
        else { var w1 = 2 * h[i] + h[i - 1], w2 = h[i] + 2 * h[i - 1]; s[i] = (w1 + w2) / (w1 / d[i - 1] + w2 / d[i]); }
      }
      s[0] = cvEnd(h[0], h[1], d[0], d[1]);
      s[n - 1] = cvEnd(h[n - 2], h[n - 3], d[n - 2], d[n - 3]);
    }
    return { x: x, y: y, h: h, s: s, setup: setup, minOrder: c.minOrder, lamPerMsi: c.laminationPerMsi };
  }
  // kappa at an order of msi MSI (flat beyond the first / last control point)
  function cvFactor(cv, msi) {
    var x = cv.x, n = x.length, lx = Math.log(msi);
    if (lx < x[0]) lx = x[0];
    if (lx > x[n - 1]) lx = x[n - 1];
    var i = 0;
    while (i < n - 2 && lx > x[i + 1]) i++;
    var h = cv.h[i], t = (lx - x[i]) / h, t2 = t * t, t3 = t2 * t;
    return Math.exp((2 * t3 - 3 * t2 + 1) * cv.y[i] + (t3 - 2 * t2 + t) * h * cv.s[i] + (-2 * t3 + 3 * t2) * cv.y[i + 1] + (t3 - t2) * h * cv.s[i + 1]);
  }
  // Hard check: can this curve be turned into prices at all? Returns "" when yes, else a message. (Unlike cvProblems this does NOT care
  // whether totals fall with more MSI: such a curve may be published on purpose after an explicit confirmation.)
  function cvBuildable(cfg) {
    var c, cv, i, j, p, sizes = [[1, 1], [2, 2], [3, 5], [10, 10]];
    try { c = normalizeCurveConfig(cfg); } catch (e) { return String(e.message || e); }
    cv = cvPrep(c);
    if (!cv) return "The curve could not be built from these points.";
    for (i = 0; i < cv.y.length; i++) if (!isFinite(cv.y[i]) || !isFinite(cv.s[i])) return "The curve has numbers out of range.";
    for (i = 0; i < sizes.length; i++) for (j = 0; j <= 60; j++) {
      p = calcQuote({ unit: "in", width: sizes[i][0], height: sizes[i][1], quantity: Math.round(2 * Math.pow(500000, j / 60)), format: "Die-cut labels", material: "Matte" }, cv).price;
      if (!isFinite(p) || p <= 0) return "The curve gives an invalid price (" + sizes[i][0] + "x" + sizes[i][1] + ").";
    }
    return "";
  }
  // Problems worth a red warning ([] = fine; publishing with problems needs an explicit confirmation): totals falling with more MSI, or ordering MORE labels costing LESS for some size.
  // cvProblemList gives each problem with its place on the chart: {text, kind: "total" | "size" | "config", msi (where to draw the marker; 0 = nowhere), size, q, prevQ}.
  // "total": the offending control point; "size": the middle (in MSI) of the step where a bigger order costs less for that label size.
  function cvProblems(cfg) { return cvProblemList(cfg).map(function (b) { return b.text; }); }
  function cvProblemList(cfg) {
    var c, cv, bad = [], i;
    try { c = normalizeCurveConfig(cfg); } catch (e) { return [{ text: String(e.message || e), kind: "config", msi: 0 }]; }
    cv = cvPrep(c);
    if (!cv) return [{ text: "The curve could not be built from these points.", kind: "config", msi: 0 }];
    for (i = 1; i < c.points.length; i++) {
      var t0 = c.points[i - 1].msi * c.points[i - 1].rate, t1 = c.points[i].msi * c.points[i].rate; // (setup fee is the same at every point)
      if (t1 < t0 - 0.005) bad.push({ kind: "total", msi: c.points[i].msi, ptIndex: i, text: "At " + c.points[i].msi + " MSI the total ($" + t1.toFixed(2) + ") is lower than at " + c.points[i - 1].msi + " MSI ($" + t0.toFixed(2) + "): a bigger order would cost less." });
    }
    var sizes = [[1, 1], [1, 2], [2, 2], [3, 5], [4, 4], [6, 6], [10, 10]], a, j, q, p, prev, prevQ;
    for (a = 0; a < sizes.length; a++) {
      prev = 0; prevQ = 0;
      for (j = 0; j <= 90; j++) {
        q = Math.round(100 * Math.pow(1000, j / 90));
        p = calcQuote({ unit: "in", width: sizes[a][0], height: sizes[a][1], quantity: q, format: "Die-cut labels", material: "Matte" }, cv).price;
        if (!isFinite(p) || p <= 0) { bad.push({ kind: "size", size: sizes[a][0] + "x" + sizes[a][1], q: q, prevQ: prevQ, msi: Math.max(0.25, sizes[a][0] * sizes[a][1]) * q / 1000, text: "Price for " + sizes[a][0] + "x" + sizes[a][1] + " at " + q + " labels is not a valid number." }); break; }
        if (prev && p < prev - 0.005) { var ar = Math.max(0.25, sizes[a][0] * sizes[a][1]); bad.push({ kind: "size", size: sizes[a][0] + "x" + sizes[a][1], q: q, prevQ: prevQ, msi: Math.sqrt((ar * q / 1000) * (ar * prevQ / 1000)), text: "For " + sizes[a][0] + "x" + sizes[a][1] + " labels, " + q.toLocaleString("en-US") + " labels would cost $" + p.toFixed(2) + ", less than " + prevQ.toLocaleString("en-US") + " labels ($" + prev.toFixed(2) + ")." }); break; }
        prev = p; prevQ = q;
      }
    }
    return bad;
  }
  function calcQuote(state, cv) {
    if (Number(state.quantity) === PENNY_TEST_QTY) {
      return { price: PENNY_TEST_PRICE, msiRate: 0 };
    }
    if (cv === undefined) cv = CV;
    var widthInches = state.unit === "cm" ? state.width / 2.54 : state.width;
    var heightInches = state.unit === "cm" ? state.height / 2.54 : state.height;
    var area = Math.max(0.25, widthInches * heightInches);
    var formatRate = state.format === "Roll labels" ? 1.12 : state.format === "Label sheets" ? 1.08 : 1;
    var materialRate =
      state.material === "Gold foil" ? 1.38 :
      state.material === "Silver foil" ? 1.35 :
      state.material === "Raised UV" ? 1.28 :
      state.material === "Freezer grade" ? 1.22 :
      state.material === "Clear" ? 1.14 :
      state.material === "Glossy" ? 1.06 : 1;
    var qty = Number(state.quantity);
    var msi = (area * qty) / 1000;
    var list = SL_SETUP + slVariable(slEffLen(widthInches, heightInches), qty);
    var price = list * SL_UPLIFT * formatRate * materialRate;
    var floor = 50;
    if (cv) { // editable curve published from the pricing editor: scales the built-in price by curve / built-in at this order size
      var k = cvFactor(cv, msi);
      if (k > 0 && isFinite(k)) { price = price * k; floor = cv.minOrder; }
    }
    price = Math.max(floor, Math.round(price * 100) / 100);
    if (cv && (!isFinite(price) || price < 0.01)) price = isFinite(price) ? 0.01 : 50; // safety net for a published curve (e.g. minimum order 0): never $0 / NaN
    if (state.starterPack && qty === STARTER_PACK_QTY) price = STARTER_PACK_PRICE;
    if (state.stickerPromo && qty === STICKER_PROMO_QTY) price = STICKER_PROMO_PRICE;
    // Lamination: + laminationPerMsi x label-face MSI (same MSI as the curve: width x height x qty / 1000), added on top of the curve / minimum-order price
    var lamCost = 0;
    if (state.lamination === "Gloss" || state.lamination === "Matte") {
      lamCost = Math.round((cv && cv.lamPerMsi >= 0 ? cv.lamPerMsi : LAM_PER_MSI_DEFAULT) * msi * 100) / 100;
      price = Math.round((price + lamCost) * 100) / 100;
    }
    // effective all-in $/MSI (price / label MSI); 0 = "don't show" (tiny jobs where the fixed part dominates)
    var msiRate = Math.round((price / msi) * 100) / 100;
    if (!(msiRate > 0 && msiRate < 100)) msiRate = 0;
    return { price: price, msiRate: msiRate, laminationCost: lamCost };
  }
  // END PRICING (sinalite110+curve)

  // Published price curve (edited in the admin price-curve editor). Until it arrives / if it fails, the built-in formula above is used;
  // the server always re-prices at add-to-cart, so a stale estimate can never be charged.
  (function loadPublishedCurve() {
    try {
      var tc = window.themeCart || {};
      var url = tc.quoteConfigUrl || (tc.quoteVariantUrl ? tc.quoteVariantUrl.replace(/quote-variant\/?$/, "quote-config") : "https://2daylabels.com/apps/artwork-upload/quote-config");
      fetch(url, { cache: "no-store" }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (!j || !j.ok) return;
        var ok = setCurveConfig(j.builtin ? null : j.config);
        if (!j.builtin && !ok) setCurveConfig(null);
        document.dispatchEvent(new CustomEvent("twoday:quote-config"));
      }).catch(function () { /* keep built-in formula */ });
    } catch (e) { /* ignore */ }
  })();

  function setActive(buttons, matchFn) {
    buttons.forEach(function (btn) {
      var on = matchFn(btn);
      btn.classList.toggle("active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      var em = btn.querySelector("em");
      if (on && !em) {
        em = document.createElement("em");
        em.textContent = "✓";
        btn.appendChild(em);
      } else if (!on && em) {
        em.remove();
      }
    });
  }

  function presetLabel(w, h, unit) {
    if (unit === "in") return w + " × " + h + " in";
    var wd = (w * 2.54).toFixed(w === 1 ? 2 : 1);
    var hd = (h * 2.54).toFixed(h === 1 ? 2 : 1);
    return wd + " × " + hd + " cm";
  }

  // —— "Revise order" support: remember the quote (and artwork file) when heading to the
  // approval page, restore it when the customer comes back with ?revise=1.
  var RESTORE_KEY = "2day_quote_restore";
  var RESTORE_DB = "2day_quote_restore";
  function openRestoreDb() {
    return new Promise(function (resolve, reject) {
      if (!window.indexedDB) { reject(new Error("no idb")); return; }
      var req = indexedDB.open(RESTORE_DB, 1);
      req.onupgradeneeded = function () { req.result.createObjectStore("files"); };
      req.onsuccess = function () { resolve(req.result); };
      req.onerror = function () { reject(req.error); };
    });
  }
  function idbFile(mode, value, key) {
    key = key || "artwork"; // design 1 = "artwork", extra designs = "artwork-2", "artwork-3", …
    return openRestoreDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction("files", mode);
        var store = tx.objectStore("files");
        var req = mode === "readonly" ? store.get(key)
          : (value ? store.put(value, key) : store.delete(key));
        tx.oncomplete = function () { db.close(); resolve(req.result); };
        tx.onerror = tx.onabort = function () { db.close(); reject(tx.error); };
      });
    });
  }
  function withTimeout(promise, ms) {
    return Promise.race([promise, new Promise(function (resolve) { setTimeout(resolve, ms); })]);
  }
  function saveQuoteRestore(data, file, extraFiles) {
    var json = JSON.stringify(data);
    try { sessionStorage.setItem(RESTORE_KEY, json); } catch (e) { /* ignore */ }
    try { localStorage.setItem(RESTORE_KEY, json); } catch (e) { /* ignore */ }
    // Store the artwork bytes as an ArrayBuffer: some WebKit/Safari builds refuse Blob/File
    // values in IndexedDB, but ArrayBuffers work everywhere.
    function put(f, key) {
      var meta = f ? { name: f.name, type: f.type, lastModified: f.lastModified } : null;
      return !f
        ? idbFile("readwrite", null, key)
        : (typeof f.arrayBuffer === "function"
            ? f.arrayBuffer()
            : new Promise(function (resolve, reject) { var fr = new FileReader(); fr.onload = function () { resolve(fr.result); }; fr.onerror = function () { reject(fr.error); }; fr.readAsArrayBuffer(f); })
          ).then(function (buf) {
            return idbFile("readwrite", Object.assign({ buf: buf }, meta), key);
          }).catch(function () {
            return idbFile("readwrite", Object.assign({ file: f }, meta), key);
          });
    }
    var jobs = [put(file, "artwork").catch(function () {})];
    (extraFiles || []).forEach(function (f, i) { jobs.push(put(f, "artwork-" + (i + 2)).catch(function () {})); });
    return withTimeout(Promise.all(jobs).catch(function () {}), extraFiles && extraFiles.length ? 5000 : 2500);
  }
  var RESTORE_MAX_AGE = 7 * 24 * 60 * 60 * 1000; // saved quotes expire after ~7 days
  function readQuoteRestore() {
    var raw = null, data = null;
    // localStorage first (survives iOS tab reloads); sessionStorage as a fallback.
    try { raw = localStorage.getItem(RESTORE_KEY); } catch (e) { /* ignore */ }
    if (!raw) { try { raw = sessionStorage.getItem(RESTORE_KEY); } catch (e) { /* ignore */ } }
    if (!raw) return null;
    try { data = JSON.parse(raw); } catch (e) { return null; }
    if (!data || typeof data !== "object") return null;
    if (!data.ts || Date.now() - Number(data.ts) > RESTORE_MAX_AGE) {
      try { localStorage.removeItem(RESTORE_KEY); sessionStorage.removeItem(RESTORE_KEY); } catch (e) { /* ignore */ }
      idbFile("readwrite", null).catch(function () {});
      return null;
    }
    return data;
  }
  function isReviseVisit() {
    try { return new URLSearchParams(window.location.search).get("revise") === "1"; } catch (e) { return false; }
  }
  // Deep links / size pages: preselect the builder from the URL (?shape=round&w=2&h=2&material=matte&qty=1000&format=roll)
  // or from data-order-width / data-order-height on the page's [data-order-format] element. Invalid values are ignored.
  var ROLL_SHAPE_ALIASES = { round: "Round", circle: "Round", oval: "Oval", ellipse: "Oval", square: "Square", rectangle: "Rectangle", rect: "Rectangle" };
  var FORMAT_ALIASES = { roll: "Roll labels", rolls: "Roll labels", "roll-labels": "Roll labels", "die-cut": "Die-cut labels", diecut: "Die-cut labels", "kiss-cut": "Kiss-cut labels", kisscut: "Kiss-cut labels", sheet: "Label sheets", sheets: "Label sheets", "label-sheets": "Label sheets", contour: "Contour cut", "contour-cut": "Contour cut", "custom-shape": "Contour cut", custom: "Contour cut", decal: "Contour cut", decals: "Contour cut" };
  function presetSize(v, max) {
    var n = Number(v);
    if (!isFinite(n) || n < 0.25 || n > max) return null;
    return Math.round(n * 100) / 100;
  }
  function readUrlPreset() {
    var out = {}, sp;
    try { sp = new URLSearchParams(window.location.search); } catch (e) { return out; }
    var unit = (sp.get("unit") || "in").toLowerCase() === "cm" ? "cm" : "in";
    // "format" is reserved by the Shopify storefront (?format= returns 404), so links use ?type= (or ?label=); format is still read for compatibility.
    var fRaw = sp.get("type") || sp.get("label") || sp.get("format") || "";
    var f = fRaw.toLowerCase().trim();
    if (FORMAT_ALIASES[f]) out.format = FORMAT_ALIASES[f];
    else if (FORMATS.indexOf(fRaw) !== -1) out.format = fRaw;
    var shape = ROLL_SHAPE_ALIASES[(sp.get("shape") || "").toLowerCase().trim()];
    if (shape) { out.rollShape = shape; if (!out.format) out.format = "Roll labels"; }
    var m = (sp.get("material") || "").toLowerCase().trim();
    for (var i = 0; i < MATERIALS.length; i++) if (MATERIALS[i].toLowerCase() === m || MATERIALS[i].toLowerCase().replace(/ /g, "-") === m) out.material = MATERIALS[i];
    var w = presetSize(sp.get("w") || sp.get("width"), unit === "cm" ? 31 : 12.2);
    var h = presetSize(sp.get("h") || sp.get("height"), unit === "cm" ? 60 : 24);
    if (w && h) { out.width = w; out.height = h; out.unit = unit; }
    var q = Number(sp.get("qty") || sp.get("quantity"));
    if (isFinite(q) && Math.floor(q) === q && q >= 100 && q <= 10000000) out.quantity = Math.max(MIN_ORDER_QTY, q);
    return out;
  }
  function readAttrPreset(el) {
    var out = {};
    if (!el) return out;
    var w = presetSize(el.getAttribute("data-order-width"), 12.2);
    var h = presetSize(el.getAttribute("data-order-height"), 24);
    if (w && h) { out.width = w; out.height = h; out.unit = "in"; }
    return out;
  }

  // Browser back / iPhone swipe-back that reloaded the page (no bfcache).
  function isBackNavigation() {
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
      if (nav) return nav.type === "back_forward";
      return !!(performance.navigation && performance.navigation.type === 2);
    } catch (e) { return false; }
  }
  var quoteRestoreUsed = false;

  function init(root) {
    if (!root || root.dataset.qbReady === "true") return;
    root.dataset.qbReady = "true";

    var state = {
      format: normalizeFormat("Die-cut labels"),
      material: "Matte",
      rollShape: "Round",
      rollDirection: "TOP",
      stickerPromo: false, // Sticker promo: exactly 50 stickers, flat $19 (+ lamination), single design
      starterPack: false, // Starter Pack: exactly 100 labels, flat $39 (+ lamination), single design
      lamination: "None", // None | Gloss | Matte — laminate film over the print (separate from the material / finish)
      width: 2,
      height: 2,
      unit: "in",
      quantity: DEFAULT_QTY,
      artwork: null,
      artworkAnalysis: null,
      dieView: "both",
      roundedCorners: false, // 2026-10-29 Tony: optional 1/8" rounded corners on square / rectangle die lines
      dieTransform: { scale: 1, rotation: 0, offsetX: 0, offsetY: 0 },
      analyzing: false,
      previewUrl: "",
      fileError: "",
      fileWarning: "",
      cartError: "",
      adding: false,
      added: false,
      contour: { id: "", fileKey: "", artPreview: "", analysis: null, cut: null, offsetMm: 1.5, whiteBorder: true, busy: false, error: "", seq: 0, drive: "w" }
    };
    var pendingContour = false;
    function isContour() { return state.format === CONTOUR_FORMAT; }

    var preset = document.querySelector("[data-order-format]");
    if (preset) {
      var presetFormat = preset.getAttribute("data-order-format");
      var presetMaterial = preset.getAttribute("data-order-material");
      var presetRollShape = preset.getAttribute("data-order-roll-shape");
      if (presetFormat) state.format = normalizeFormat(presetFormat);
      if (presetMaterial) state.material = normalizeMaterial(presetMaterial);
      if (presetRollShape) state.rollShape = presetRollShape;
    }

    // Proof area can live outside the form (left column of .quote-section).
    var qbScope = (root.closest && root.closest(".quote-section")) || root;
    function pick(sel) {
      return root.querySelector(sel) || (qbScope !== root ? qbScope.querySelector(sel) : null);
    }
    var proofBox = qbScope.querySelector("[data-quote-proof]");
    var proofOutline = proofBox && proofBox.querySelector("[data-proof-outline]");
    var proofOutlineSize = proofBox && proofBox.querySelector("[data-proof-outline-size]");
    var proofSizeEl = proofBox && proofBox.querySelector("[data-proof-size]");
    var proofPlaceholderText = proofBox && proofBox.querySelector("[data-proof-placeholder-text]");
    var proofMobileSlot = root.querySelector("[data-proof-mobile-slot]");
    var proofPlaceholder = proofBox && proofBox.querySelector("[data-proof-placeholder]");
    var proofChooseBtn = proofBox && proofBox.querySelector("[data-proof-choose]");
    var proofCartBtn = proofBox && proofBox.querySelector("[data-proof-cart]");
    var proofCartLabel = proofBox && proofBox.querySelector("[data-proof-cart-label]");
    var proofCartError = proofBox && proofBox.querySelector("[data-proof-cart-error]");

    var formatBtns = root.querySelectorAll("[data-format]");
    var formatSelect = root.querySelector("[data-format-select]");
    var materialSelect = root.querySelector("[data-material-select]");
    var materialBtns = root.querySelectorAll("[data-material]");
    // Lamination (2026-10-09): None / Gloss / Matte film, + $/MSI from the published curve (laminationPerMsi, default $0.50)
    var LAMINATIONS = ["None", "Gloss", "Matte"];
    var lamBtns = Array.prototype.slice.call(root.querySelectorAll("[data-lamination]"));
    var CORNER_RADIUS_IN = 0.125; // 1/8" = 3.175 mm, fixed physical radius at any label size
    function cornersEligible() { var s = previewShape(); return !isContour() && (s === "square" || s === "rectangle"); }
    function cornersOn() { return !!state.roundedCorners && cornersEligible(); }
    function cornersProp() { return 'Rounded 1/8"'; }
    function lamOn() { return state.lamination === "Gloss" || state.lamination === "Matte"; }
    function chooseLamination(v) {
      if (LAMINATIONS.indexOf(v) === -1 || v === state.lamination) return;
      state.lamination = v;
      state.added = false;
      state.cartError = "";
      render();
    }
    function renderLamination() {
      lamBtns.forEach(function (b) {
        var on = b.getAttribute("data-lamination") === state.lamination;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-checked", on ? "true" : "false");
        b.tabIndex = on ? 0 : -1;
      });
    }
    var rollSetup = root.querySelector("[data-roll-setup]");
    var rollShapeBtns = root.querySelectorAll("[data-roll-shape]");
    var rollDirBtns = root.querySelectorAll("[data-roll-direction]");
    var presetBtns = root.querySelectorAll("[data-preset-w]");
    var widthInput = root.querySelector("[data-width]");
    var heightInput = root.querySelector("[data-height]");
    var unitLabels = root.querySelectorAll("[data-unit-label]");
    var unitBtns = root.querySelectorAll("[data-unit]");
    var qtyInput = root.querySelector("[data-quantity]");
    var qtyBtns = root.querySelectorAll("[data-qty]");
    var qtySelect = root.querySelector("[data-qty-select]");
    var customQtyWrap = root.querySelector("[data-custom-qty]");
    var qtyCustomMode = false;

    // The on-screen price is an instant client estimate (same formula as the server).
    // The charged price always comes from the server (quote-variant response); if it
    // ever differs, the server figure replaces the estimate for those exact selections.
    var serverQuote = null; // { key, price, msiRate }
    function selectionKey() {
      return [state.format, state.material, state.lamination, state.starterPack ? "sp" : "", state.stickerPromo ? "stk" : "", state.unit, state.width, state.height, state.quantity, designs ? designs.map(function (d) { return d.qty; }).join("x") : ""].join("|");
    }
    function currentQuote() {
      if (serverQuote && serverQuote.key === selectionKey()) {
        return { price: serverQuote.price, msiRate: serverQuote.msiRate };
      }
      return calcQuote(isContour() ? Object.assign({}, state, { format: "Roll labels" }) : state);
    }
    function qtyInList(n) {
      if (!qtySelect) return false;
      for (var i = 0; i < qtySelect.options.length; i++) {
        if (qtySelect.options[i].value !== "custom" && Number(qtySelect.options[i].value) === Number(n)) return true;
      }
      return false;
    }
    if (qtySelect) {
      Array.prototype.forEach.call(qtySelect.options, function (opt) {
        if (opt.value === "custom" || opt.value === "starter" || opt.value === "sticker") return;
        var n = Number(opt.value);
        opt.textContent = n.toLocaleString() + (n === PENNY_TEST_QTY ? " label ($0.01 test)" : " labels");
      });
    }
    var fileDrop = root.querySelector("[data-file-drop]");
    var fileInput = root.querySelector("[data-file-input]");
    var dropTitle = root.querySelector("[data-drop-title]");
    var uploaded = root.querySelector("[data-uploaded-file]");
    var previewEl = pick("[data-file-preview]");
    var fileNameEl = root.querySelector("[data-file-name]");
    var fileMetaEl = root.querySelector("[data-file-meta]");
    var fileErrorEl = root.querySelector("[data-file-error]");
    var fileWarningEl = root.querySelector("[data-file-warning]");
    var dpiBadgeEl = root.querySelector("[data-dpi-badge]");
    var artworkStatusEl = root.querySelector("[data-artwork-status]");
    var artworkStatusRow = root.querySelector("[data-artwork-status-row]");
    var dieMsgEl = root.querySelector("[data-artwork-die-msg]");
    var dieToggles = pick("[data-die-toggles]");
    var dieControls = pick("[data-die-controls]");
    var dieRotateInput = pick("[data-die-rotate]");
    var dieRotateVal = pick("[data-die-rotate-val]");
    var dieResetBtn = pick("[data-die-reset]");
    var dieFitBtn = pick("[data-die-fit]");
    var uploadProgress = root.querySelector("[data-upload-progress]");
    var fileRemove = root.querySelector("[data-file-remove]");
    var specEl = root.querySelector("[data-spec-summary]");
    var priceEl = root.querySelector("[data-price]");
    var priceEachEl = root.querySelector("[data-price-each]");
    var addBtn = root.querySelector("[data-add-btn]");
    var cartErrorEl = root.querySelector("[data-cart-error]");

    qtyBtns.forEach(function (btn) {
      var n = Number(btn.getAttribute("data-qty"));
      btn.textContent = n.toLocaleString();
    });

    // ——— Multiple designs, one size (2026-10-09) ———
    // Customers can add several designs (artwork files) of the same size / material / label type.
    // Each design has its own artwork, proof and quantity; the price tier comes from the COMBINED
    // quantity. The existing uploader + proof card always edit the "active" design: switching swaps
    // the per-design fields in and out of `state`. designs === null → classic single-design flow.
    var MIN_DESIGN_QTY = 25;
    var MAX_DESIGNS = 20;
    var DESIGN_FIELDS = ["artwork", "artworkAnalysis", "previewUrl", "dieTransform", "dieView", "fileError", "fileWarning"];
    var designs = null;
    var activeDesign = 0;
    var recheckingAll = false;
    var designsPanel = null;
    var designsPanelSig = "";
    var uploadLabelEl = root.querySelector(".upload-label");
    var uploadLabelHtml = uploadLabelEl ? uploadLabelEl.innerHTML : "";
    var qtyFieldset = root.querySelector(".quantity-fieldset");
    var qtySelectWrap = qtyFieldset && qtyFieldset.querySelector(".qb-select-wrap");
    var qtyMultiNote = null;

    function blankDesign(qty) {
      return { qty: qty, artwork: null, artworkAnalysis: null, previewUrl: "", dieTransform: defaultDieTransform(), dieView: "both", fileError: "", fileWarning: "" };
    }
    function snapshotActive() {
      if (!designs || !designs[activeDesign]) return;
      var d = designs[activeDesign];
      DESIGN_FIELDS.forEach(function (k) { d[k] = state[k]; });
    }
    function loadDesign(i) {
      if (!designs || !designs[i]) return;
      activeDesign = i;
      var d = designs[i];
      DESIGN_FIELDS.forEach(function (k) { state[k] = d[k]; });
      if (!state.dieTransform) state.dieTransform = defaultDieTransform();
      if (!state.dieView) state.dieView = "both";
      if (fileInput) fileInput.value = "";
    }
    function switchDesign(i) {
      if (!designs || i === activeDesign || !designs[i] || state.analyzing || state.adding) return;
      snapshotActive();
      loadDesign(i);
      state.cartError = "";
      render();
    }
    function designTotalQty() {
      if (!designs) return state.quantity;
      return designs.reduce(function (s, d) { return s + (Number(d.qty) || 0); }, 0);
    }
    function syncDesignQty() {
      if (designs) state.quantity = Math.max(1, designTotalQty());
    }
    function designQtyKey() {
      return designs ? designs.map(function (d) { return d.qty; }).join("x") : "";
    }
    // Same split as the server (cents floored, remainder from design 1) so lines add up to the total.
    function splitDesignCents(totalCents, qtys) {
      var sum = qtys.reduce(function (a, b) { return a + b; }, 0) || 1;
      var out = qtys.map(function (q) { return Math.floor((totalCents * q) / sum); });
      var rem = totalCents - out.reduce(function (a, b) { return a + b; }, 0);
      for (var i = 0; rem > 0; i = (i + 1) % out.length, rem--) out[i] += 1;
      return out;
    }
    function separateDesignsPrice() {
      if (!designs) return 0;
      var base = isContour() ? Object.assign({}, state, { format: "Roll labels" }) : state;
      return designs.reduce(function (s, d) { return s + calcQuote(Object.assign({}, base, { quantity: d.qty })).price; }, 0);
    }
    function addDesign() {
      if (state.analyzing || state.adding || isContour()) return;
      if (state.starterPack) { showCartError("The Starter Pack is for one design. Choose 500+ labels to add more designs."); return; }
      if (state.stickerPromo) { showCartError("The sticker promo is for one design. Choose 500+ labels to add more designs."); return; }
      if (!designs) {
        var q0 = Number(state.quantity) || DEFAULT_QTY;
        if (q0 < MIN_DESIGN_QTY) q0 = 100;
        designs = [blankDesign(q0)];
        activeDesign = 0;
        snapshotActive();
      } else {
        if (designs.length >= MAX_DESIGNS) return;
        snapshotActive();
      }
      var lastQty = designs[designs.length - 1].qty;
      designs.push(blankDesign(lastQty));
      loadDesign(designs.length - 1);
      syncDesignQty();
      state.added = false;
      state.cartError = "";
      render();
      var target = fileDrop && !fileDrop.hidden ? fileDrop : uploadLabelEl;
      if (target && target.scrollIntoView) {
        try { target.scrollIntoView({ block: "center", behavior: "smooth" }); } catch (e) { target.scrollIntoView(); }
      }
    }
    function dropDesignAssets(d) {
      if (!d) return;
      if (d.previewUrl) { try { URL.revokeObjectURL(d.previewUrl); } catch (e) { /* ignore */ } }
      if (d.artworkAnalysis && window.ArtworkUpload) { try { window.ArtworkUpload.revoke(d.artworkAnalysis); } catch (e) { /* ignore */ } }
    }
    function removeDesign(i) {
      if (!designs || !designs[i] || state.analyzing || state.adding) return;
      if (i === activeDesign) {
        revokePreview();
      } else {
        snapshotActive();
        dropDesignAssets(designs[i]);
      }
      designs.splice(i, 1);
      var next = i === activeDesign ? Math.min(i, designs.length - 1) : (i < activeDesign ? activeDesign - 1 : activeDesign);
      if (designs.length === 1) {
        var only = designs[0];
        activeDesign = 0;
        loadDesign(0);
        state.quantity = only.qty;
        designs = null;
        qtyCustomMode = !qtyInList(state.quantity);
      } else {
        loadDesign(next);
        syncDesignQty();
      }
      state.added = false;
      state.cartError = "";
      render();
    }
    // Restore helper: analyze a file straight into a (possibly inactive) design slot.
    function analyzeIntoDesign(i, file, pend) {
      var d = designs && designs[i];
      if (!d || !file) return;
      function done() { if (designs && designs[activeDesign] === d) loadDesign(activeDesign); render(); }
      if (!(window.ArtworkUpload && typeof window.ArtworkUpload.analyze === "function")) {
        d.artwork = file;
        done();
        return;
      }
      window.ArtworkUpload.analyze(file, toInches()).then(function (a) {
        if (!designs || designs.indexOf(d) === -1) return;
        if (!a || a.reject) { d.fileError = (a && a.message) || "Artwork was rejected."; done(); return; }
        d.artwork = file;
        d.artworkAnalysis = a;
        d.previewUrl = a.previewUrl || "";
        d.dieTransform = Object.assign(defaultDieTransform(), (pend && pend.dieTransform) || {});
        d.dieView = (pend && pend.dieView) || "both";
        d.fileError = "";
        d.fileWarning = a.warning ? a.message : "";
        done();
      }).catch(function () { d.artwork = file; done(); });
    }
    function recheckAllDesigns() {
      snapshotActive();
      var keep = activeDesign;
      recheckingAll = true;
      try {
        for (var i = 0; i < designs.length; i++) {
          loadDesign(i);
          if (state.artwork) recheckArtworkForSize();
          snapshotActive();
        }
      } finally {
        recheckingAll = false;
      }
      loadDesign(keep);
      render();
    }
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
    }
    function money(n) { return "$" + (Math.round(n * 100) / 100).toFixed(2); }
    function designThumbSrc(d) {
      if (d.artworkAnalysis && d.artworkAnalysis.previewUrl) return d.artworkAnalysis.previewUrl;
      if (d.previewUrl) return d.previewUrl;
      return "";
    }
    function injectDesignStyles() {
      if (document.getElementById("qb-designs-css")) return;
      var st = document.createElement("style");
      st.id = "qb-designs-css";
      st.textContent = [
        ".qb-designs{margin:14px 0 4px;border:2px solid var(--ink,#111);border-radius:16px;background:#fff;padding:14px;display:grid;gap:10px;color:var(--ink,#111)}",
        ".qb-designs.is-single{border-style:dashed;background:rgba(255,255,255,.55);padding:12px 14px}",
        ".qb-designs-head{display:flex;flex-direction:column;gap:2px}",
        ".qb-designs-head b{font-size:15px}",
        ".qb-designs-head small{font-size:12.5px;opacity:.75;line-height:1.35}",
        ".qb-design-list{list-style:none;margin:0;padding:0;display:grid;gap:8px}",
        ".qb-design{display:grid;grid-template-columns:minmax(0,1fr) auto auto auto;align-items:center;gap:8px;border:1.5px solid rgba(0,0,0,.18);border-radius:12px;padding:6px 8px;background:#fafafa}",
        ".qb-design.is-active{border-color:var(--ink,#111);background:#f3ffd6;box-shadow:3px 3px 0 var(--ink,#111)}",
        ".qb-design-pick{all:unset;cursor:pointer;display:flex;align-items:center;gap:10px;min-width:0}",
        ".qb-design-pick:focus-visible{outline:2px solid var(--ink,#111);outline-offset:3px;border-radius:8px}",
        ".qb-design-thumb{width:42px;height:42px;flex:0 0 42px;border-radius:8px;border:1px solid rgba(0,0,0,.2);background:#fff center/contain no-repeat;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;overflow:hidden}",
        ".qb-design-thumb img{width:100%;height:100%;object-fit:contain}",
        ".qb-design-txt{display:flex;flex-direction:column;min-width:0}",
        ".qb-design-txt b{font-size:14px}",
        ".qb-design-txt small{font-size:12px;opacity:.72;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}",
        ".qb-design-txt em{font-style:normal;font-size:11px;font-weight:700;color:#3b6d00}",
        ".qb-designs .qb-design-qty{display:flex!important;flex-direction:row!important;align-items:center;gap:6px;margin:0!important;padding:0!important;font-size:12px;font-weight:600;grid-template-columns:none}",
        ".qb-designs .qb-design-qty span{font-size:12px!important;letter-spacing:0!important;text-transform:none!important;margin:0!important;font-weight:600}",
        ".qb-designs .qb-design-qty input{width:84px;min-height:0!important;height:auto!important;margin:0!important;padding:7px 8px!important;border:1.5px solid var(--ink,#111);border-radius:9px;font:inherit;font-size:14px!important;background:#fff}",
        ".qb-design-price{font-weight:700;font-size:14px;min-width:62px;text-align:right}",
        ".qb-design-remove{all:unset;cursor:pointer;width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:18px;line-height:1}",
        ".qb-design-remove:hover,.qb-design-remove:focus-visible{background:rgba(0,0,0,.08)}",
        ".qb-design-add{cursor:pointer;justify-self:start;border:2px solid var(--ink,#111);background:var(--lime,#c6f432);color:var(--ink,#111);border-radius:999px;padding:9px 16px;font:inherit;font-weight:700;font-size:14px}",
        ".qb-design-add[disabled]{opacity:.5;cursor:not-allowed}",
        ".qb-designs.is-single .qb-design-add{background:#fff}",
        ".qb-designs-total{margin:0;font-size:13px;line-height:1.45}",
        ".qb-designs-total b{font-size:14px}",
        ".qb-designs-save{display:inline-block;margin-top:2px;background:#e9ffc2;border:1px solid #9bd10f;border-radius:999px;padding:2px 9px;font-weight:700;font-size:12.5px}",
        ".qb-designs-err{margin:0;color:#b00020;font-size:12.5px;font-weight:600}",
        ".qb-qty-multi{margin:6px 0 0;font-size:13.5px;font-weight:600;line-height:1.4}",
        "@media (max-width:560px){.qb-design{grid-template-columns:minmax(0,1fr) auto;grid-template-areas:'pick remove' 'qty price'}.qb-design-pick{grid-area:pick}.qb-design-remove{grid-area:remove}.qb-design-qty{grid-area:qty}.qb-design-price{grid-area:price}.qb-design-qty input{width:96px}}"
      ].join("\n");
      document.head.appendChild(st);
    }
    function ensureDesignsPanel() {
      if (designsPanel) return designsPanel;
      injectDesignStyles();
      designsPanel = document.createElement("div");
      designsPanel.className = "qb-designs";
      designsPanel.setAttribute("data-qb-designs", "");
      var anchor = specEl || null;
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(designsPanel, anchor);
      else root.appendChild(designsPanel);
      designsPanel.addEventListener("click", function (e) {
        var t = e.target;
        var add = t.closest("[data-design-add]");
        if (add) { e.preventDefault(); addDesign(); return; }
        var rm = t.closest("[data-design-remove]");
        if (rm) { e.preventDefault(); removeDesign(Number(rm.getAttribute("data-design-remove"))); return; }
        var pk = t.closest("[data-design-pick]");
        if (pk) { e.preventDefault(); switchDesign(Number(pk.getAttribute("data-design-pick"))); }
      });
      designsPanel.addEventListener("input", function (e) {
        var inp = e.target.closest("[data-design-qty]");
        if (!inp || !designs) return;
        var i = Number(inp.getAttribute("data-design-qty"));
        var n = Math.floor(Number(inp.value));
        if (!designs[i] || !isFinite(n) || n < 1) return;
        designs[i].qty = Math.min(10000000, n);
        syncDesignQty();
        state.added = false;
        state.cartError = "";
        render();
      });
      designsPanel.addEventListener("change", function (e) {
        var inp = e.target.closest("[data-design-qty]");
        if (!inp || !designs) return;
        var i = Number(inp.getAttribute("data-design-qty"));
        if (!designs[i]) return;
        var n = Math.floor(Number(inp.value));
        designs[i].qty = Math.min(10000000, Math.max(MIN_DESIGN_QTY, isFinite(n) ? n : MIN_DESIGN_QTY));
        inp.value = designs[i].qty;
        syncDesignQty();
        state.added = false;
        render();
      });
      return designsPanel;
    }
    function renderDesigns(quote) {
      var panel = ensureDesignsPanel();
      // Decals (cut around artwork) are one design per order for now.
      panel.hidden = isContour() && !designs;
      if (qtyFieldset) {
        if (!qtyMultiNote) {
          qtyMultiNote = document.createElement("p");
          qtyMultiNote.className = "qb-qty-multi";
          qtyMultiNote.hidden = true;
          qtyFieldset.appendChild(qtyMultiNote);
        }
        if (qtySelectWrap) qtySelectWrap.hidden = !!designs;
        if (designs && customQtyWrap) customQtyWrap.hidden = true;
        qtyMultiNote.hidden = !designs;
        if (designs) qtyMultiNote.textContent = designTotalQty().toLocaleString() + " labels total across " + designs.length + " designs — set each design’s quantity under “Designs” below.";
      }
      if (uploadLabelEl) {
        if (designs) {
          var cur = designs[activeDesign];
          uploadLabelEl.innerHTML = "Artwork file — Design " + (activeDesign + 1) + " of " + designs.length +
            " <span>" + (cur ? cur.qty.toLocaleString() + " labels · " : "") + "upload this design’s file, or send it after ordering</span>";
        } else if (uploadLabelEl.innerHTML !== uploadLabelHtml) {
          uploadLabelEl.innerHTML = uploadLabelHtml;
        }
      }
      if (!designs) {
        panel.classList.add("is-single");
        var sigS = "single|" + (isContour() ? 1 : 0);
        if (designsPanelSig !== sigS) {
          designsPanelSig = sigS;
          panel.innerHTML =
            '<div class="qb-designs-head"><b>More than one design in this size?</b>' +
            "<small>Add each design here — the quantities combine, so every design gets the lower volume price.</small></div>" +
            '<button type="button" class="qb-design-add" data-design-add>+ Add another design</button>';
        }
        var addS = panel.querySelector("[data-design-add]");
        if (addS) addS.disabled = !!state.analyzing || !!state.adding || !!state.starterPack || !!state.stickerPromo;
        var spN = panel.querySelector("[data-sp-note]");
        if (!spN) { spN = document.createElement("small"); spN.className = "qb-sp-note"; spN.setAttribute("data-sp-note", ""); spN.textContent = "The Starter Pack is for one design — choose 500+ labels to add more designs."; panel.appendChild(spN); }
        spN.textContent = state.stickerPromo ? "The sticker promo is for one design — choose 500+ labels to add more designs." : "The Starter Pack is for one design — choose 500+ labels to add more designs.";
        spN.hidden = !state.starterPack && !state.stickerPromo;
        return;
      }
      snapshotActive();
      panel.classList.remove("is-single");
      var sig = "multi|" + activeDesign + "|" + designs.map(function (d) { return (d.artwork ? d.artwork.name + d.artwork.size : "-") + ":" + designThumbSrc(d); }).join("|");
      if (designsPanelSig !== sig) {
        designsPanelSig = sig;
        var items = designs.map(function (d, i) {
          var src = designThumbSrc(d);
          var ext = d.artwork ? (d.artwork.name.split(".").pop() || "").toUpperCase().slice(0, 4) : "";
          var thumb = src ? '<img src="' + esc(src) + '" alt="">' : (ext ? esc(ext) : "+");
          var name = d.artwork ? esc(d.artwork.name) : (d.fileError ? "File rejected — upload again" : "No file yet — tap to upload");
          return '<li class="qb-design' + (i === activeDesign ? " is-active" : "") + '">' +
            '<button type="button" class="qb-design-pick" data-design-pick="' + i + '" aria-pressed="' + (i === activeDesign) + '">' +
            '<span class="qb-design-thumb">' + thumb + "</span>" +
            '<span class="qb-design-txt"><b>Design ' + (i + 1) + "</b><small>" + name + "</small>" + (i === activeDesign ? "<em>Editing ↑</em>" : "") + "</span></button>" +
            '<label class="qb-design-qty"><span>Qty</span><input type="number" inputmode="numeric" min="' + MIN_DESIGN_QTY + '" step="1" data-design-qty="' + i + '" value="' + d.qty + '" aria-label="Design ' + (i + 1) + ' quantity"></label>' +
            '<span class="qb-design-price" data-design-price="' + i + '"></span>' +
            '<button type="button" class="qb-design-remove" data-design-remove="' + i + '" aria-label="Remove design ' + (i + 1) + '">×</button></li>';
        }).join("");
        panel.innerHTML =
          '<div class="qb-designs-head"><b>Designs in this order</b><small>Same size, material and label type. Quantities combine for the volume price.</small></div>' +
          '<ol class="qb-design-list">' + items + "</ol>" +
          '<button type="button" class="qb-design-add" data-design-add>+ Add another design</button>' +
          '<p class="qb-designs-err" data-designs-err hidden></p>' +
          '<p class="qb-designs-total" data-designs-total></p>';
      }
      var qtys = designs.map(function (d) { return d.qty; });
      var shares = splitDesignCents(Math.round(quote.price * 100), qtys);
      designs.forEach(function (d, i) {
        var pe = panel.querySelector('[data-design-price="' + i + '"]');
        if (pe) pe.textContent = money(shares[i] / 100);
        var qi = panel.querySelector('[data-design-qty="' + i + '"]');
        if (qi && document.activeElement !== qi && Number(qi.value) !== d.qty) qi.value = d.qty;
      });
      var addM = panel.querySelector("[data-design-add]");
      if (addM) addM.disabled = designs.length >= MAX_DESIGNS || !!state.analyzing || !!state.adding;
      var errEl = panel.querySelector("[data-designs-err]");
      var low = designs.map(function (d, i) { return d.qty < MIN_DESIGN_QTY ? "Design " + (i + 1) : ""; }).filter(Boolean);
      if (errEl) {
        var msg = isContour() ? "Multiple designs aren’t available for Decals yet — choose Rolls or Sheets, or remove the extra designs." :
          (low.length ? low.join(", ") + ": minimum " + MIN_DESIGN_QTY + " labels per design." :
          designTotalQty() < MIN_ORDER_QTY ? "Minimum order is " + MIN_ORDER_QTY + " labels in total across all designs." : "");
        errEl.hidden = !msg;
        errEl.textContent = msg;
      }
      var totalEl = panel.querySelector("[data-designs-total]");
      if (totalEl) {
        var total = designTotalQty();
        var sep = separateDesignsPrice();
        var save = sep - quote.price;
        totalEl.innerHTML = "<b>" + total.toLocaleString() + " labels</b> across " + designs.length + " designs · priced at the " +
          total.toLocaleString() + "-label rate: <b>" + money(quote.price) + "</b>" +
          (save >= 0.5 ? '<br><span class="qb-designs-save">You save ' + money(save) + " vs. ordering each design separately (" + money(sep) + ")</span>" : "");
      }
    }

    // ——— Multi-design add to cart: one cart line per design, each priced at its share of the
    // combined-quantity total (server-priced via /quote-variant designQuantities + designIndex). ———
    function designLineProps(d, i, n, total, info, groupId) {
      var q = d.qty;
      var props = {
        Format: state.format,
        Material: materialLabel(state.material),
        Size: sizeLabel(),
        Design: (i + 1) + " of " + n,
        Quantity: String(q) + " labels",
        "Label quantity": String(q),
        "Combined quantity": total.toLocaleString() + " labels (" + n + " designs, volume price)",
        "Artwork filename": d.artwork ? d.artwork.name : "To be sent after ordering",
        "Artwork check": d.artworkAnalysis && d.artworkAnalysis.checkLabel ? d.artworkAnalysis.checkLabel : (d.artwork ? "Uploaded" : "None"),
        "Estimated total": "$" + Number(info.total).toFixed(2),
        _quoted_price: Number(info.total).toFixed(2),
        _price_mode: info.priceMode || "pack",
        _unit_price: info.unitPrice,
        _line_total: info.lineTotal,
        _design_index: String(i + 1),
        _design_count: String(n),
        _design_group: groupId
      };
      if (info.roundingDiffCents) props._rounding_diff_cents = String(info.roundingDiffCents);
      if (state.format === "Label sheets") props.Shape = state.rollShape;
      if (state.format === "Roll labels") {
        props["Roll shape"] = state.rollShape;
        props.Unwind = state.rollDirection + " unwind";
      }
      if (cornersOn()) props.Corners = cornersProp();
      if (lamOn()) props.Lamination = state.lamination;
      if (d.artwork && d.dieTransform) {
        var dt = d.dieTransform;
        props["Artwork transform"] = "scale " + (Math.round((dt.scale || 1) * 100) / 100) + " / rot " + Math.round(dt.rotation || 0) + "°";
      }
      return props;
    }

    function addDesignsToCart() {
      snapshotActive();
      if (isContour()) { showCartError("Multiple designs aren’t available for Decals yet. Choose Rolls or Sheets, or remove the extra designs."); return; }
      for (var k = 0; k < designs.length; k++) {
        if (!(designs[k].qty >= MIN_DESIGN_QTY)) { showCartError("Design " + (k + 1) + " needs at least " + MIN_DESIGN_QTY + " labels."); return; }
      }
      if (designTotalQty() < MIN_ORDER_QTY) { showCartError("Minimum order is " + MIN_ORDER_QTY + " labels in total across all designs."); return; }
      var config = window.themeCart || {};
      var addUrl = config.addUrl || "/cart/add.js";
      var cartJsUrl = config.cartJsUrl || "/cart.js";
      var clearUrl = config.clearUrl || "/cart/clear.js";
      var quoteVariantUrl = config.quoteVariantUrl || "https://2daylabels.com/apps/artwork-upload/quote-variant";
      var uploadSecret = config.uploadSecret || "";
      if (!uploadSecret) { showCartError("Missing upload secret for quote variant API."); return; }
      state.adding = true;
      state.added = false;
      state.cartError = "";
      render();
      var quote = currentQuote();
      var list = designs.slice();
      var qtys = list.map(function (d) { return d.qty; });
      var n = list.length;
      var total = qtys.reduce(function (a, b) { return a + b; }, 0);
      var groupId = Math.random().toString(16).slice(2, 10);
      var clientShares = splitDesignCents(Math.round(quote.price * 100), qtys);
      var infos = [];
      function createFor(i) {
        return __2dApiFetch(quoteVariantUrl, {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json", "X-2Day-Secret": uploadSecret },
          body: JSON.stringify({
            secret: uploadSecret,
            format: state.format,
            material: state.material,
            width: promoSendW(),
            height: promoSendH(),
            unit: state.unit,
            quantity: qtys[i],
            designQuantities: qtys,
            designIndex: i,
            rollShape: state.format === "Roll labels" || state.format === "Label sheets" ? state.rollShape : undefined,
            lamination: lamOn() ? state.lamination : undefined,
            corners: cornersOn() ? cornersProp() : undefined,
            starterPack: state.starterPack && !designs ? true : undefined,
            stickerPromo: state.stickerPromo && !designs ? true : undefined,
            rollDirection: state.format === "Roll labels" ? state.rollDirection : undefined,
            clientTotal: clientShares[i] / 100
          })
        }).then(function (res) {
          return res.text().then(function (text) {
            var data = {};
            try { data = text ? JSON.parse(text) : {}; } catch (err) { data = { error: text }; }
            if (!res.ok || !data.ok || !data.variantId) throw new Error(__2dErrText(data, "Could not create quote price."));
            if (!data.designGroup) throw new Error("The pricing server doesn’t support multiple designs yet. Please try again in a minute.");
            return data;
          });
        });
      }
      var origs = [];
      var chain = __2dOriginalsWithin(list.map(function (d) { return d.artwork; }), uploadSecret, 45000).then(function (o) { origs = o || []; });
      list.forEach(function (d, i) { chain = chain.then(function () { return createFor(i).then(function (info) { infos[i] = info; }); }); });
      chain
        .then(function () {
          var serverTotal = infos.reduce(function (s, info) { return s + (Number(info.totalCents) || 0); }, 0) / 100;
          if (isFinite(serverTotal) && serverTotal > 0) {
            serverQuote = { key: selectionKey(), price: serverTotal, msiRate: Number(infos[0].msiRate) || quote.msiRate };
            quote = { price: serverTotal, msiRate: serverQuote.msiRate };
          }
          var items = list.map(function (d, i) {
            var lp = designLineProps(d, i, n, total, infos[i], groupId);
            if (origs[i]) { lp["Original file"] = origs[i]; lp._original_url = origs[i]; }
            return { id: infos[i].variantId, quantity: Number(infos[i].cartQuantity) || 1, properties: lp };
          }).reverse(); // Shopify lists the newest line first → add design N first so the cart reads Design 1, 2, …
          window.__2dLastGroup = groupId; window.__2dLastItemKey = ""; return Promise.resolve().then(function () { // multi-item cart: add, never clear
            return fetch(addUrl, {
              method: "POST",
              credentials: "same-origin",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ items: items })
            }).then(function (res) {
              return res.text().then(function (text) {
                var data = {};
                try { data = text ? JSON.parse(text) : {}; } catch (err) { data = { description: text }; }
                if (!res.ok || (data.status && Number(data.status) >= 400)) throw new Error(data.description || data.message || "Could not add to cart.");
                return data;
              });
            });
          });
        })
        .then(function () {
          return fetch(cartJsUrl, { credentials: "same-origin", headers: { Accept: "application/json" } }).then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          var lines = cart && cart.items ? cart.items.filter(function (it) { return it.properties && it.properties._design_group === groupId; }).length : n;
          if (lines !== n) throw new Error("Only " + lines + " of " + n + " designs made it into the cart. Please try again.");
          updateCartCount(cart && cart.items ? cart.items.length : n);
          state.adding = false;
          state.added = true;
          render();
          stashDesignsAndGo(quote, infos).catch(function () {
            window.location.href = (config.approveUrl || "/pages/approve-artwork");
          });
        })
        .catch(function (err) {
          showCartError(err && err.message ? err.message : "Could not add to cart.");
        });
    }

    function captureDesignShots() {
      // Paint each design into the proof card in turn and capture art / die / combined preview.
      snapshotActive();
      var keep = activeDesign;
      var shots = [];
      var chain = Promise.resolve();
      designs.forEach(function (d, i) {
        chain = chain.then(function () {
          loadDesign(i);
          if (state.artwork) paintArtworkPreview();
          if (!state.artwork) { shots[i] = { artworkDataUrl: null, dieDataUrl: null, previewDataUrl: null }; return; }
          return Promise.all([captureArtworkDataUrl(), captureDieDataUrl()]).then(function (pair) {
            return captureApprovalPreview(pair[0] || null, pair[1] || null).then(function (prev) {
              shots[i] = { artworkDataUrl: pair[0] || null, dieDataUrl: pair[1] || null, previewDataUrl: prev || null };
            });
          });
        });
      });
      return chain.then(function () {
        loadDesign(keep);
        render();
        return shots;
      }, function (e) { loadDesign(keep); render(); throw e; });
    }

    function stashDesignsAndGo(quote, infos) {
      var approveUrl = (window.themeCart && window.themeCart.approveUrl) || "/pages/approve-artwork";
      return captureDesignShots().then(function (shots) {
        var n = designs.length;
        var total = designTotalQty();
        var keep = activeDesign;
        loadDesign(0);
        var payload = buildApprovalPayload(quote, null, null, null);
        loadDesign(keep);
        payload.specs.qty = total.toLocaleString() + " labels (" + n + " designs)";
        payload.designCount = n;
        payload.totalQuantity = total;
        payload.designs = designs.map(function (d, i) {
          var s = shots[i] || {};
          var info = (infos && infos[i]) || {};
          return {
            index: i + 1,
            qty: d.qty,
            fileName: d.artwork ? d.artwork.name : "To be sent after ordering",
            checkLabel: d.artworkAnalysis && d.artworkAnalysis.checkLabel ? d.artworkAnalysis.checkLabel : (d.artwork ? "Uploaded" : "None"),
            dieTransform: d.artwork && d.dieTransform ? d.dieTransform : { scale: 1, rotation: 0, offsetX: 0, offsetY: 0 },
            dieView: d.artwork ? d.dieView : "both",
            quotedPrice: info.total != null ? Number(info.total) : null,
            artworkDataUrl: s.artworkDataUrl || undefined,
            previewDataUrl: s.previewDataUrl || undefined,
            dieDataUrl: s.dieDataUrl || undefined
          };
        });
        // Quota fallbacks: drop the die PNG (server builds the CUT PATH PDF), then previews, then art.
        if (!tryStashPayload(payload)) {
          payload.designs.forEach(function (d) { delete d.dieDataUrl; });
          if (!tryStashPayload(payload)) {
            payload.designs.forEach(function (d) { delete d.previewDataUrl; });
            if (!tryStashPayload(payload)) {
              payload.designs.forEach(function (d) { delete d.artworkDataUrl; });
              tryStashPayload(payload);
            }
          }
        }
        var d0 = designs[0];
        var restore = {
          v: 1,
          ts: Date.now(),
          path: window.location.pathname,
          format: state.format,
          material: materialLabel(state.material),
          rollShape: state.rollShape,
          rollDirection: state.rollDirection,
          lamination: state.lamination,
          width: promoSendW(),
          height: promoSendH(),
          unit: state.unit,
          quantity: total,
          hasArtwork: !!d0.artwork,
          fileName: d0.artwork ? d0.artwork.name : "",
          dieTransform: d0.artwork ? d0.dieTransform : null,
          dieView: d0.artwork ? d0.dieView : "both",
          contourOffsetMm: state.contour.offsetMm,
          contourWhiteBorder: state.contour.whiteBorder,
          designs: designs.map(function (d) {
            return { qty: d.qty, hasArtwork: !!d.artwork, fileName: d.artwork ? d.artwork.name : "", dieTransform: d.artwork ? d.dieTransform : null, dieView: d.artwork ? d.dieView : "both" };
          })
        };
        var extra = designs.slice(1).map(function (d) { return d.artwork || null; });
        return saveQuoteRestore(restore, d0.artwork || null, extra).then(function () {
          window.location.href = approveUrl;
        });
      });
    }

    function isPresetActive(w, h) {
      var m = state.unit === "cm" ? 2.54 : 1;
      return Math.abs(state.width - w * m) < 0.02 && Math.abs(state.height - h * m) < 0.02;
    }

    function toInches() {
      if (state.unit === "cm") {
        return { widthIn: state.width / 2.54, heightIn: state.height / 2.54 };
      }
      if (state.unit === "mm") {
        return { widthIn: state.width / 25.4, heightIn: state.height / 25.4 };
      }
      return { widthIn: state.width, heightIn: state.height };
    }

    // ---------------- contour cut engine ----------------
    var contourSetup = root.querySelector("[data-contour-setup]");
    var contourOffsetInput = root.querySelector("[data-contour-offset]");
    var contourOffsetVal = root.querySelector("[data-contour-offset-val]");
    var contourWhiteInput = root.querySelector("[data-contour-white]");
    var contourStatusEl = root.querySelector("[data-contour-status]");
    var contourSizeNote = root.querySelector("[data-contour-size-note]");
    var proofHintEl = qbScope.querySelector(".quote-proof-hint");
    var proofHintDefault = proofHintEl ? proofHintEl.textContent : "";
    function round2(n) { return Math.round(n * 100) / 100; }
    function decalCopy(s) {
      return String(s || "").replace(/\b(contour[- ]cut labels|contour labels|custom shape labels)\b/gi, "Decals").replace(/\bcustom shape\b/gi, "decals");
    }
    function contourUrl(path) {
      var c = window.themeCart || {};
      var base = (c.quoteVariantUrl || "https://2daylabels.com/apps/artwork-upload/quote-variant").replace(/quote-variant\/?$/, "");
      return base + "contour/" + path;
    }
    function contourPost(path, body) {
      var c = window.themeCart || {};
      body.secret = c.uploadSecret || "";
      body.previewToken = window.__contourPreviewToken || "";
      return __2dApiFetch(contourUrl(path), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-2Day-Secret": body.secret },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.text().then(function (t) {
          var j = {};
          try { j = t ? JSON.parse(t) : {}; } catch (e) { j = { error: res.status === 413 ? "That file is too large for decals (30 MB max)." : "The cut-line service is busy — please try again." }; }
          if (!res.ok || !j.ok) throw new Error(decalCopy(__2dErrText(j, "Could not make a cut line for this file.")));
          return j;
        });
      });
    }
    function contourFileDataUrl(file) {
      return new Promise(function (resolve, reject) {
        var isRaster = /^image\/(png|jpeg|webp)$/.test(file.type || "");
        var big = file.size > 8 * 1024 * 1024;
        if (isRaster && big) {
          // very large rasters: re-encode at <= 4000 px (keeps transparency) so the upload stays small
          var url = URL.createObjectURL(file), img = new Image();
          img.onload = function () {
            try {
              var k = Math.min(1, 4000 / Math.max(img.naturalWidth, img.naturalHeight));
              var cv = document.createElement("canvas");
              cv.width = Math.round(img.naturalWidth * k); cv.height = Math.round(img.naturalHeight * k);
              cv.getContext("2d").drawImage(img, 0, 0, cv.width, cv.height);
              URL.revokeObjectURL(url);
              resolve(cv.toDataURL(file.type === "image/jpeg" ? "image/jpeg" : "image/png", 0.95));
            } catch (e) { URL.revokeObjectURL(url); reject(e); }
          };
          img.onerror = function () { URL.revokeObjectURL(url); reject(new Error("Could not read this image.")); };
          img.src = url;
          return;
        }
        if (file.size > 30 * 1024 * 1024) { reject(new Error("That file is too large for decals (30 MB max).")); return; }
        var fr = new FileReader();
        fr.onload = function () { resolve(String(fr.result || "")); };
        fr.onerror = function () { reject(new Error("Could not read this file.")); };
        fr.readAsDataURL(file);
      });
    }
    function resetContour() {
      var keep = state.contour || {};
      state.contour = { id: "", fileKey: "", artPreview: "", analysis: null, cut: null, offsetMm: keep.offsetMm || 1.5, whiteBorder: keep.whiteBorder !== false, busy: false, error: "", seq: (keep.seq || 0) + 1, drive: "w" };
    }
    function applyContourCut(cut, drive) {
      if (!cut || !cut.cutIn) return;
      var k = state.unit === "cm" ? 2.54 : 1;
      state.contour.cut = cut;
      if (drive === "h") state.width = round2(cut.cutIn[0] * k);
      else state.height = round2(cut.cutIn[1] * k);
      if (state.stickerPromo && state.promoSide) { state.width = state.promoSide; state.height = state.promoSide; } // promo: square size box, art fitted inside
    }
    // Promo decal: the size box shows the square, but the server checks the real cut box (artwork shape), so send that.
    function promoCutDims() {
      if (!(state.stickerPromo && isContour() && state.contour && state.contour.cut && state.contour.cut.cutIn)) return null;
      var k = state.unit === "cm" ? 2.54 : 1;
      return [round2(state.contour.cut.cutIn[0] * k), round2(state.contour.cut.cutIn[1] * k)];
    }
    function promoSendW() { var d = promoCutDims(); return d ? d[0] : state.width; }
    function promoSendH() { var d = promoCutDims(); return d ? d[1] : state.height; }
    // 2026-10-14: sticker promo = square size box (default 3 x 3 in). The decal cut is sized so its longer side = the square side.
    function promoSquare(side) {
      var k = state.unit === "cm" ? 2.54 : 1;
      var sd = round2(side || state.promoSide || 3 * k);
      state.promoSide = sd; state.width = sd; state.height = sd;
      if (isContour() && state.contour && state.contour.id) {
        var c = state.contour.cut, ar = c && c.cutIn && c.cutIn[1] > 0 ? c.cutIn[0] / c.cutIn[1] : 1;
        contourRecut(ar >= 1 ? "w" : "h");
      }
    }
    function contourAnalyze(file) {
      if (!file) return;
      var ext = (file.name.split(".").pop() || "").toLowerCase();
      if (["png", "jpg", "jpeg", "webp", "pdf"].indexOf(ext) === -1) {
        resetContour();
        state.contour.error = "Decals need a PNG, JPG, WEBP or PDF file (from Illustrator, save a PDF or a PNG with a transparent background).";
        render();
        return;
      }
      var key = file.name + "|" + file.size + "|" + (file.lastModified || 0);
      if (state.contour.fileKey === key && (state.contour.id || state.contour.busy)) return;
      resetContour();
      var seq = state.contour.seq;
      state.contour.fileKey = key;
      state.contour.busy = true;
      render();
      contourFileDataUrl(file)
        .then(function (dataUrl) {
          var inches = toInches();
          return contourPost("analyze", { fileBase64: dataUrl, fileName: file.name, widthIn: Math.max(CONTOUR_MIN_IN, inches.widthIn), offsetMm: state.contour.offsetMm, whiteBorder: state.contour.whiteBorder });
        })
        .then(function (j) {
          if (seq !== state.contour.seq) return;
          state.contour.id = j.id;
          state.contour.artPreview = j.artPreview || "";
          state.contour.analysis = j.analysis || null;
          state.contour.busy = false;
          state.contour.error = j.cut ? "" : (j.cutError || "Could not make a cut line at this size — try a larger width.");
          if (j.cut) {
            var k = state.unit === "cm" ? 2.54 : 1;
            if (toInches().widthIn < CONTOUR_MIN_IN) state.width = round2(j.cut.cutIn[0] * k);
            applyContourCut(j.cut, "w");
            if (state.stickerPromo) { state.added = false; promoSquare(state.promoSide); return; }
          }
          state.added = false;
          render();
        })
        .catch(function (e) {
          if (seq !== state.contour.seq) return;
          state.contour.busy = false;
          state.contour.error = (e && e.message) || "Could not make a cut line for this file.";
          render();
        });
    }
    var contourTimer = null;
    function contourRecut(drive) {
      if (!state.contour.id) return;
      state.contour.drive = drive || state.contour.drive || "w";
      var c = state.contour.cut;
      if (c && c.cutIn && c.cutIn[1] > 0 && !state.stickerPromo) { // instant estimate in the artwork's proportions; the server answer replaces it
        var ar = c.cutIn[0] / c.cutIn[1];
        if (state.contour.drive === "h") state.width = round2(state.height * ar);
        else state.height = round2(state.width / ar);
      }
      state.contour.busy = true;
      state.contour.seq += 1;
      var seq = state.contour.seq;
      clearTimeout(contourTimer);
      contourTimer = setTimeout(function () {
        var inches = toInches();
        var body = { id: state.contour.id, offsetMm: state.contour.offsetMm, whiteBorder: state.contour.whiteBorder };
        if (state.contour.drive === "h") body.heightIn = inches.heightIn; else body.widthIn = inches.widthIn;
        contourPost("cut", body)
          .then(function (j) {
            if (seq !== state.contour.seq) return;
            state.contour.busy = false;
            state.contour.error = "";
            applyContourCut(j.cut, state.contour.drive);
            render();
          })
          .catch(function (e) {
            if (seq !== state.contour.seq) return;
            state.contour.busy = false;
            state.contour.error = (e && e.message) || "Could not update the cut line.";
            render();
          });
      }, 300);
    }
    function contourBlockReason() {
      var c = state.contour;
      if (!state.artwork && !c.id) return "Decals need your artwork — upload it and we'll cut around it.";
      if (c.busy) return "Still working out your cut line — try again in a second.";
      if (c.error) return c.error;
      if (!c.id || !c.cut) return "We couldn't make a cut line for this file yet. Please upload it again.";
      if (c.cut.problems && c.cut.problems.length) return decalCopy(c.cut.problems.join(" "));
      var inches = toInches();
      if (inches.widthIn < CONTOUR_MIN_IN - 0.005 || inches.heightIn < CONTOUR_MIN_IN - 0.005) return "Decals must be at least 1 in (2.54 cm) on each side.";
      return "";
    }
    function contourPathD(pts) {
      var out = "";
      for (var i = 0; i < pts.length; i++) out += (i ? "L" : "M") + pts[i][0].toFixed(2) + " " + pts[i][1].toFixed(2);
      return out + "Z";
    }
    /** SVG proof (mm units): label stock (white), artwork, magenta dashed cut line. forExport = static, white background. */
    function contourSvg(forExport) {
      var c = state.contour, cut = c.cut;
      if (!cut || !c.artPreview) return "";
      var W = cut.cutMm[0], H = cut.cutMm[1], L = Math.max(W, H), pad = L * 0.05 + (cut.bleedMm || 1);
      var a = cut.artBoxMm, d = contourPathD(cut.cutPathMm), uid = "cp" + (c.seq || 0);
      var sw = (L / 170).toFixed(3), dash = (L / 45).toFixed(2) + " " + (L / 70).toFixed(2), cyc = -(L / 45 + L / 70);
      var img = '<image href="' + c.artPreview + '" x="' + a[0] + '" y="' + a[1] + '" width="' + a[2] + '" height="' + a[3] + '" preserveAspectRatio="none"/>';
      var grow = Math.max(0.3, (cut.offsetMm || 1.5) + (cut.bleedMm || 1));
      return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="' + (-pad) + " " + (-pad) + " " + (W + 2 * pad) + " " + (H + 2 * pad) + '"' +
        (forExport ? ' width="' + Math.round((W + 2 * pad) * 12) + '" height="' + Math.round((H + 2 * pad) * 12) + '"' : "") + ' role="img" aria-label="Proof: your artwork with the cut line">' +
        "<defs>" +
        '<pattern id="' + uid + 'k" width="' + (L / 25) + '" height="' + (L / 25) + '" patternUnits="userSpaceOnUse"><rect width="' + (L / 25) + '" height="' + (L / 25) + '" fill="#ecebe6"/><rect width="' + (L / 50) + '" height="' + (L / 50) + '" fill="#f8f7f3"/><rect x="' + (L / 50) + '" y="' + (L / 50) + '" width="' + (L / 50) + '" height="' + (L / 50) + '" fill="#f8f7f3"/></pattern>' +
        '<clipPath id="' + uid + 'c"><path d="' + d + '"/></clipPath>' +
        '<filter id="' + uid + 'g" x="-20%" y="-20%" width="140%" height="140%"><feMorphology operator="dilate" radius="' + (grow * 0.6).toFixed(2) + '"/><feGaussianBlur stdDeviation="' + (grow * 0.45).toFixed(2) + '"/><feComponentTransfer><feFuncA type="linear" slope="40" intercept="0"/></feComponentTransfer></filter>' +
        "</defs>" +
        '<rect x="' + (-pad) + '" y="' + (-pad) + '" width="' + (W + 2 * pad) + '" height="' + (H + 2 * pad) + '" fill="' + (forExport ? "#ffffff" : "url(#" + uid + "k)") + '"/>' +
        '<path d="' + d + '" fill="#ffffff" stroke="rgba(0,0,0,.16)" stroke-width="' + (L / 400).toFixed(3) + '"/>' +
        (c.whiteBorder ? "" : '<g clip-path="url(#' + uid + 'c)"><g filter="url(#' + uid + 'g)">' + img + "</g></g>") +
        img +
        '<path class="contour-cut-line" d="' + d + '" fill="none" stroke="#ff00ff" stroke-width="' + sw + '" stroke-linejoin="round" stroke-dasharray="' + dash + '"' + (forExport ? "" : ' style="--cd:' + cyc.toFixed(2) + '"') + "/>" +
        "</svg>";
    }
    function renderContourProof() {
      var c = state.contour;
      var key = [c.cut ? c.cut.cutMm.join("x") + "/" + c.cut.offsetMm : "", c.whiteBorder, c.busy, c.error, state.width, state.height, state.unit, (c.artPreview || "").length].join("|");
      if (previewEl.__contourKey === key && previewEl.querySelector(".contour-proof")) return;
      previewEl.__contourKey = key;
      previewEl.innerHTML = "";
      var wrap = document.createElement("div");
      wrap.className = "contour-proof";
      var svg = contourSvg(false);
      if (!svg) {
        var msg = document.createElement("span");
        msg.textContent = c.error ? c.error : "Finding your artwork's outline…";
        wrap.appendChild(msg);
        previewEl.appendChild(wrap);
        return;
      }
      wrap.innerHTML = svg;
      var size = document.createElement("span");
      size.className = "contour-proof-size";
      size.textContent = state.width + " × " + state.height + " " + state.unit;
      wrap.appendChild(size);
      if (c.busy) {
        var busy = document.createElement("span");
        busy.className = "contour-proof-busy";
        busy.textContent = "Updating…";
        wrap.appendChild(busy);
      }
      var legend = document.createElement("p");
      legend.className = "contour-proof-legend";
      legend.innerHTML = "<i></i>Magenta line = where we cut" + (c.whiteBorder ? " · white = label edge" : " · art colour runs to the cut");
      wrap.appendChild(legend);
      previewEl.appendChild(wrap);
      var line = wrap.querySelector(".contour-cut-line");
      if (line && line.animate) {
        try { line.animate([{ strokeDashoffset: 0 }, { strokeDashoffset: Number(line.style.getPropertyValue("--cd")) || -8 }], { duration: 1200, iterations: Infinity }); } catch (e) { /* static line */ }
      }
    }
    /** Proof image for the approval page / receipt (JPEG data URL). */
    function contourCompositeDataUrl() {
      return new Promise(function (resolve) {
        var svg = contourSvg(true);
        if (!svg) { resolve(null); return; }
        var img = new Image();
        img.onload = function () {
          try {
            var k = Math.min(1, 1000 / Math.max(img.naturalWidth || img.width, img.naturalHeight || img.height));
            var cv = document.createElement("canvas");
            cv.width = Math.max(1, Math.round((img.naturalWidth || img.width) * k));
            cv.height = Math.max(1, Math.round((img.naturalHeight || img.height) * k));
            var ctx = cv.getContext("2d");
            ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, cv.width, cv.height);
            ctx.drawImage(img, 0, 0, cv.width, cv.height);
            resolve(cv.toDataURL("image/jpeg", 0.85));
          } catch (e) { resolve(null); }
        };
        img.onerror = function () { resolve(null); };
        img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
      });
    }
    function renderContourControls() {
      var on = isContour();
      if (contourSetup) contourSetup.hidden = !on;
      if (contourSizeNote) contourSizeNote.hidden = !on;
      if (proofHintEl) proofHintEl.textContent = on ? "The magenta line is where we cut — set the size and cut offset on the right." : proofHintDefault;
      if (!on) return;
      var c = state.contour;
      if (contourOffsetInput && document.activeElement !== contourOffsetInput) contourOffsetInput.value = String(c.offsetMm);
      if (contourOffsetVal) contourOffsetVal.textContent = c.offsetMm + " mm";
      if (contourWhiteInput) contourWhiteInput.checked = c.whiteBorder !== false;
      if (!contourStatusEl) return;
      var cls = "", txt = "";
      if (c.busy) { txt = c.cut ? "Updating cut line…" : "Finding your artwork's outline…"; }
      else if (c.error) { txt = c.error; cls = "is-error"; }
      else if (!state.artwork && !c.id) { txt = "Upload your artwork below — we'll find its outline and draw the cut line around it."; cls = "is-warn"; }
      else if (c.cut && c.cut.problems && c.cut.problems.length) { txt = decalCopy(c.cut.problems.join(" ")); cls = "is-error"; }
      else if (c.cut) {
        var warn = (c.cut.warnings || []).filter(function (w) { return !/neck/i.test(w); });
        txt = (c.busy ? "Updating cut line… " : "✓ Cut line ready: ") + state.width + " × " + state.height + " " + state.unit + " · " + c.offsetMm + " mm offset" + (warn.length ? " · Note: " + warn.join(" ") : "");
        cls = warn.length ? "is-warn" : "is-ok";
      }
      contourStatusEl.textContent = txt;
      contourStatusEl.className = "contour-status" + (cls ? " " + cls : "");
    }

    function previewShape() {
      if (isContour()) return "diecut";
      if (window.ArtworkUpload && window.ArtworkUpload.shapeFromFormat) {
        return window.ArtworkUpload.shapeFromFormat(state.format, state.rollShape);
      }
      if (state.format === "Oval labels") return "oval";
      if (state.format === "Round labels") return "round";
      if (state.format === "Square labels") return "square";
      if (state.format === "Rectangle labels") return "rectangle";
      if (state.format === "Kiss-cut labels") return "rounded";
      if (state.format === "Die-cut labels") return "diecut";
      if (state.format === "Roll labels" || state.format === "Label sheets") {
        var rs = (state.rollShape || "").toLowerCase();
        if (rs === "oval") return "oval";
        if (rs === "round") return "round";
        if (rs === "square") return "square";
        return "rectangle";
      }
      return "rectangle";
    }

    function defaultDieTransform() {
      return { scale: 1, rotation: 0, offsetX: 0, offsetY: 0 };
    }

    function resetDieTransform(keepRotation) {
      var rot = keepRotation ? (state.dieTransform && state.dieTransform.rotation) || 0 : 0;
      state.dieTransform = { scale: 1, rotation: rot, offsetX: 0, offsetY: 0 };
    }

    function syncDieControls() {
      if (!dieControls) return;
      var t = state.dieTransform || defaultDieTransform();
      if (dieRotateInput && document.activeElement !== dieRotateInput) {
        dieRotateInput.value = String(Math.round(t.rotation));
      }
      if (dieRotateVal) {
        dieRotateVal.textContent = Math.round(t.rotation) + "°";
      }
    }

    function paintArtworkPreview() {
      if (!previewEl) return;
      if (isContour()) { renderContourProof(); return; }
      previewEl.__contourKey = "";
      if (window.ArtworkUpload && state.artworkAnalysis) {
        var inches = toInches();
        window.ArtworkUpload.renderPreview(previewEl, state.artworkAnalysis, state.dieView, {
          widthIn: inches.widthIn,
          heightIn: inches.heightIn,
          shape: previewShape(),
          cornerRadiusIn: cornersOn() ? CORNER_RADIUS_IN : 0,
          transform: state.dieTransform,
          sizeLabel: sizeLabelForPreview(inches),
          interactive: true,
          onTransformChange: function (next) {
            state.dieTransform = next;
            syncDieControls();
          }
        });
      } else {
        previewEl.innerHTML = "";
        if (state.previewUrl) {
          var img = document.createElement("img");
          img.src = state.previewUrl;
          img.alt = "Artwork preview";
          previewEl.appendChild(img);
        } else if (state.artwork) {
          var span = document.createElement("span");
          span.textContent = (state.artwork.name.split(".").pop() || "").toUpperCase();
          previewEl.appendChild(span);
        }
      }
      syncDieControls();
    }

    function sizeLabelForPreview(inches) {
      inches = inches || toInches();
      var w = Number(inches.widthIn);
      var h = Number(inches.heightIn);
      function fmt(n) {
        var s = n.toFixed(2);
        return s.replace(/\.?0+$/, "");
      }
      return fmt(w) + " × " + fmt(h) + " in";
    }

    function revokePreview() {
      if (state.previewUrl) {
        URL.revokeObjectURL(state.previewUrl);
        state.previewUrl = "";
      }
      if (state.artworkAnalysis && window.ArtworkUpload) {
        window.ArtworkUpload.revoke(state.artworkAnalysis);
      }
      state.artworkAnalysis = null;
    }

    var pendingRestore = null;
    function clearArtwork(keepError) {
      state.artwork = null;
      state.dieView = "both";
      state.dieTransform = defaultDieTransform();
      state.fileWarning = "";
      if (!keepError) state.fileError = "";
      revokePreview();
      resetContour();
      if (fileInput) fileInput.value = "";
    }

    function applyAnalysis(file, analysis) {
      if (!analysis || analysis.reject) {
        clearArtwork(true);
        state.fileError = (analysis && analysis.message) || "Artwork was rejected.";
        state.fileWarning = "";
        state.analyzing = false;
        render();
        return;
      }
      state.artwork = file;
      state.artworkAnalysis = analysis;
      state.dieView = "both";
      state.dieTransform = defaultDieTransform();
      if (pendingRestore) {
        if (pendingRestore.dieTransform) state.dieTransform = Object.assign({}, state.dieTransform, pendingRestore.dieTransform);
        if (pendingRestore.dieView) state.dieView = pendingRestore.dieView;
        pendingRestore = null;
      }
      state.fileError = "";
      state.fileWarning = analysis.warning ? analysis.message : "";
      if (analysis.previewUrl) {
        state.previewUrl = analysis.previewUrl;
      }
      state.analyzing = false;
      render();
    }

    function selectFile(file) {
      state.added = false;
      state.cartError = "";
      state.fileError = "";
      state.fileWarning = "";
      if (!file) return;
      var ext = (file.name.split(".").pop() || "").toLowerCase();
      if (ALLOWED_EXTENSIONS.indexOf(ext) === -1) {
        clearArtwork(true);
        state.fileError = "Please upload PNG, JPG, WEBP, PDF, AI, or EPS artwork.";
        render();
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        clearArtwork(true);
        state.fileError = "That file is over 50 MB. Please upload a smaller version.";
        render();
        return;
      }
      __2dUploadOriginal(file, (window.themeCart || {}).uploadSecret || ""); // start early; awaited at add-to-cart

      if (isContour()) contourAnalyze(file);
      // Analyze async when ArtworkUpload is available
      if (window.ArtworkUpload && typeof window.ArtworkUpload.analyze === "function") {
        state.analyzing = true;
        state.artwork = null;
        revokePreview();
        render();
        var inches = toInches();
        window.ArtworkUpload.analyze(file, inches)
          .then(function (analysis) {
            applyAnalysis(file, analysis);
          })
          .catch(function () {
            // Fallback: accept file without analysis
            state.artwork = file;
            state.artworkAnalysis = null;
            state.analyzing = false;
            if (file.type && file.type.indexOf("image/") === 0) {
              state.previewUrl = URL.createObjectURL(file);
            }
            state.fileWarning = "Could not analyze artwork in-browser — we will check at proof.";
            render();
          });
        return;
      }

      state.artwork = file;
      revokePreview();
      if (file.type && file.type.indexOf("image/") === 0) {
        state.previewUrl = URL.createObjectURL(file);
      }
      render();
    }

    function recheckArtworkForSize() {
      if (designs && !recheckingAll) { recheckAllDesigns(); return; } // multi-design: recheck every design for the new size
      // Size change: keep rotation, refit scale/offset to the new ordered die.
      if (state.artwork) resetDieTransform(true);
      if (!state.artwork || !state.artworkAnalysis || !window.ArtworkUpload) return;
      if (state.artworkAnalysis.kind !== "raster") return;
      var inches = toInches();
      var updated = window.ArtworkUpload.recheckDpi(state.artworkAnalysis, inches);
      if (updated.reject) {
        var msg = updated.message;
        clearArtwork(true);
        state.fileError = msg;
        render();
        return;
      }
      state.artworkAnalysis = updated;
      state.fileWarning = updated.warning ? updated.message : "";
      state.fileError = "";
      render();
    }

    function updateProofArea() {
      if (!proofBox) return;
      var hasArt = !!state.artwork;
      proofBox.classList.toggle("is-empty", !hasArt);
      proofBox.classList.toggle("has-artwork", hasArt);
      proofBox.classList.toggle("is-analyzing", !!state.analyzing);
      var inches = toInches();
      var ratio = inches.widthIn > 0 && inches.heightIn > 0 ? inches.widthIn / inches.heightIn : 1;
      ratio = Math.max(0.1, Math.min(10, ratio));
      proofBox.style.setProperty("--proof-ratio", ratio.toFixed(4));
      var label = state.width + " × " + state.height + " " + state.unit;
      if (proofSizeEl) proofSizeEl.textContent = label;
      if (proofOutlineSize) proofOutlineSize.textContent = label;
      if (proofOutline) proofOutline.setAttribute("data-die-shape", previewShape());
      if (proofPlaceholderText) {
        proofPlaceholderText.textContent = state.analyzing
          ? "Checking artwork…"
          : "Your proof appears here once you upload artwork";
      }
      requestProofSticky();
    }

    // Stacked layout (<=1024px): show the proof right after the upload zone.
    var proofHome = proofBox && proofBox.parentNode;
    var proofMq = window.matchMedia ? window.matchMedia("(max-width: 1024px)") : null;
    function placeProofArea() {
      if (!proofBox || !proofHome || !proofMobileSlot || !proofMq) return;
      var target = proofMq.matches ? proofMobileSlot : proofHome;
      if (proofBox.parentNode !== target) target.appendChild(proofBox);
    }
    if (proofMq) {
      if (proofMq.addEventListener) proofMq.addEventListener("change", placeProofArea);
      else if (proofMq.addListener) proofMq.addListener(placeProofArea);
    }
    placeProofArea();

    // Desktop: the proof card starts at the top of the left column content and follows the
    // scroll from there. CSS position:sticky can't engage
    // here because html/body use overflow-x:hidden, so this uses a transform, clamped so the
    // card never sits above the uploader and stops at the section bottom (24px gap).
    // While following, the card stays vertically centred in the viewport.
    var proofStickyTop = 24;
    var proofTicking = false;
    function proofAnchorEl() {
      if (uploaded && !uploaded.hidden) return uploaded;
      if (fileDrop && !fileDrop.hidden) return fileDrop;
      return uploaded || fileDrop;
    }
    function updateProofSticky() {
      proofTicking = false;
      if (!proofBox || !proofHome) return;
      if ((proofMq && proofMq.matches) || proofBox.parentNode !== proofHome) {
        proofBox.style.transform = "";
        proofHome.style.minHeight = "";
        return;
      }
      var colTop = proofHome.getBoundingClientRect().top;
      var offTop = proofBox.offsetTop;
      var cardH = proofBox.offsetHeight;
      var naturalTop = colTop + offTop;
      // Rests at its natural spot (top of the left column content, under the intro) and
      // follows the scroll across the whole orange section.
      var alignShift = 0;
      proofHome.style.minHeight = Math.ceil(offTop + cardH) + "px";
      // May run into the section's bottom padding (still orange), keeping a 24px margin.
      var limitBottom = qbScope !== root
        ? qbScope.getBoundingClientRect().bottom - 24
        : colTop + proofHome.clientHeight;
      var maxShift = Math.max(alignShift, limitBottom - (naturalTop + cardH));
      // Follow the scroll vertically centred in the viewport; if the card is taller than the
      // viewport (minus margins), fall back to pinning it 24px from the top.
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      var followTop = cardH + proofStickyTop * 2 <= vh ? (vh - cardH) / 2 : proofStickyTop;
      var shift = Math.min(maxShift, Math.max(alignShift, followTop - naturalTop));
      proofBox.style.transform = shift > 0 ? "translateY(" + Math.round(shift) + "px)" : "";
    }
    function requestProofSticky() {
      if (proofTicking) return;
      proofTicking = true;
      (window.requestAnimationFrame || setTimeout)(updateProofSticky);
    }
    if (proofBox) {
      document.addEventListener("scroll", requestProofSticky, { passive: true, capture: true });
      window.addEventListener("resize", requestProofSticky);
      if (proofMq) {
        if (proofMq.addEventListener) proofMq.addEventListener("change", requestProofSticky);
        else if (proofMq.addListener) proofMq.addListener(requestProofSticky);
      }
      window.addEventListener("load", requestProofSticky);
      // Form/card height changes (fonts, images, fieldsets toggling, preview painting).
      if (window.ResizeObserver) {
        var proofRo = new ResizeObserver(requestProofSticky);
        proofRo.observe(root);
        proofRo.observe(proofBox);
      }
    }

    function stripSpecialty() {
      if (!specialtyOff()) return;
      if (materialSelect) {
        Array.prototype.slice.call(materialSelect.options).forEach(function (op) {
          if (SPECIALTY_MATERIALS.indexOf(op.value) !== -1) op.parentNode.removeChild(op);
        });
      }
      materialBtns.forEach(function (b) {
        if (SPECIALTY_MATERIALS.indexOf(b.getAttribute("data-material")) !== -1) b.hidden = true;
      });
      var nm = normalizeMaterial(state.material);
      if (nm !== state.material) { state.material = nm; state.added = false; }
    }
    window.addEventListener("specialty-off", function () { stripSpecialty(); render(); });

    function render() {
      stripSpecialty();
      if (isContour() && !contourOn()) state.format = "Roll labels";
      // Sticker promo size cap: both sides <= 5 in. Too big while active -> back to the default quantity with a note.
      var stkOk = stickerSizeOk() && !stickerPromoOff();
      if (!state.stickerPromo && state.promoWanted && stkOk && !designs) {
        state.promoWanted = false; state.stickerPromo = true; state.starterPack = false;
        state.quantity = STICKER_PROMO_QTY; qtyCustomMode = false; state.added = false;
      }
      if (state.stickerPromo && !stkOk) {
        state.promoWanted = !stickerPromoOff();
        state.stickerPromo = false;
        state.quantity = DEFAULT_QTY;
        qtyCustomMode = false;
        state.added = false;
      }
      renderContourControls();
      setActive(formatBtns, function (b) { return b.getAttribute("data-format") === state.format; });
      if (formatSelect && formatSelect.value !== state.format) formatSelect.value = state.format;
      if (materialSelect && materialSelect.value !== state.material) materialSelect.value = state.material;
      setActive(materialBtns, function (b) { return b.getAttribute("data-material") === state.material; });
      if (rollSetup) rollSetup.hidden = !(state.format === "Roll labels" || state.format === "Label sheets");
      Array.prototype.forEach.call(root.querySelectorAll("[data-roll-only]"), function (el) { el.hidden = state.format !== "Roll labels"; });
      var shapeNote = root.querySelector("[data-shape-legend-note]");
      if (shapeNote) shapeNote.textContent = state.format === "Roll labels" ? "Choose the label shape and artwork unwind direction" : "Choose the label shape";
      var shapeTitle = root.querySelector("[data-shape-legend-title]");
      if (shapeTitle) shapeTitle.textContent = state.format === "Roll labels" ? "Roll label setup" : "Sheet label setup";
      Array.prototype.forEach.call(root.querySelectorAll("[data-format-choice]"), function (b) {
        var on = b.getAttribute("data-format-choice") === state.format;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-checked", on ? "true" : "false");
        b.tabIndex = on ? 0 : -1;
      });
      setActive(rollShapeBtns, function (b) { return b.getAttribute("data-roll-shape") === state.rollShape; });
      setActive(rollDirBtns, function (b) { return b.getAttribute("data-roll-direction") === state.rollDirection; });

      var sizePresets = root.querySelector("[data-size-presets]");
      if (sizePresets) {
        var previewShape = "rectangle";
        if (state.format === "Oval labels") previewShape = "oval";
        else if (state.format === "Round labels") previewShape = "round";
        else if (state.format === "Square labels") previewShape = "square";
        else if (state.format === "Rectangle labels") previewShape = "rectangle";
        else if (state.format === "Kiss-cut labels") previewShape = "rounded";
        else if (state.format === "Die-cut labels") previewShape = "diecut";
        else if (state.format === "Roll labels" || state.format === "Label sheets") {
          var rs = (state.rollShape || "").toLowerCase();
          if (rs === "oval") previewShape = "oval";
          else if (rs === "round") previewShape = "round";
          else if (rs === "square") previewShape = "square";
          else previewShape = "rectangle";
        }
        sizePresets.setAttribute("data-shape", previewShape);
      }

      presetBtns.forEach(function (btn) {
        var w = Number(btn.getAttribute("data-preset-w"));
        var h = Number(btn.getAttribute("data-preset-h"));
        btn.classList.toggle("active", isPresetActive(w, h));
        var label = btn.querySelector("[data-preset-label]");
        if (label) label.textContent = presetLabel(w, h, state.unit);
      });

      var maxWidth = state.unit === "in" ? 12.2 : 31;
      var maxHeight = state.unit === "in" ? 24 : 60;
      widthInput.max = maxWidth;
      heightInput.max = maxHeight;
      widthInput.setAttribute("aria-label", "Width in " + state.unit);
      heightInput.setAttribute("aria-label", "Height in " + state.unit);
      if (document.activeElement !== widthInput) widthInput.value = state.width;
      if (document.activeElement !== heightInput) heightInput.value = state.height;
      unitLabels.forEach(function (el) { el.textContent = state.unit; });
      unitBtns.forEach(function (btn) {
        btn.classList.toggle("active", btn.getAttribute("data-unit") === state.unit);
      });

      if (qtyInput && document.activeElement !== qtyInput) qtyInput.value = state.quantity;
      if (qtySelect) {
        if (state.starterPack) { qtyCustomMode = false; qtySelect.value = "starter"; }
        else if (state.stickerPromo) { qtyCustomMode = false; qtySelect.value = "sticker"; }
        else {
          if (!qtyCustomMode && !qtyInList(state.quantity)) qtyCustomMode = true;
          qtySelect.value = qtyCustomMode ? "custom" : String(state.quantity);
        }
        if (customQtyWrap) customQtyWrap.hidden = !qtyCustomMode;
      }
      qtyBtns.forEach(function (btn) {
        btn.classList.toggle("active", Number(btn.getAttribute("data-qty")) === state.quantity);
      });

      if (state.analyzing) {
        fileDrop.hidden = false;
        uploaded.hidden = true;
        dropTitle.textContent = "Checking artwork…";
        fileDrop.classList.add("is-analyzing");
      } else {
        fileDrop.classList.remove("is-analyzing");
        if (!state.artwork) dropTitle.textContent = "Drop artwork or browse";
      }

      if (state.artwork) {
        fileDrop.hidden = true;
        uploaded.hidden = false;
        uploaded.classList.add("has-preview");
        uploaded.classList.toggle("has-die", !!(state.artworkAnalysis && state.artworkAnalysis.dieFound));
        uploaded.classList.toggle("is-soft", !!(state.artworkAnalysis && state.artworkAnalysis.dpiStatus === "soft"));
        uploaded.classList.toggle("is-good", !!(state.artworkAnalysis && state.artworkAnalysis.dpiStatus === "good"));

        paintArtworkPreview();

        fileNameEl.textContent = state.artwork.name;
        var sizeMb = state.artwork.size / 1024 / 1024;
        var sizeLabel = sizeMb.toFixed(state.artwork.size > 1024 * 1024 ? 1 : 2) + " MB";
        var metaBits = [sizeLabel];
        if (state.artworkAnalysis && state.artworkAnalysis.pixels) {
          metaBits.push(state.artworkAnalysis.pixels.width + " × " + state.artworkAnalysis.pixels.height + " px");
        }
        if (state.artworkAnalysis && state.artworkAnalysis.dpi && state.artworkAnalysis.dpi.effective) {
          metaBits.push("~" + state.artworkAnalysis.dpi.effective + " DPI");
        }
        metaBits.push("Ready for proofing");
        fileMetaEl.textContent = metaBits.join(" · ");

        if (artworkStatusRow && dpiBadgeEl && artworkStatusEl && state.artworkAnalysis) {
          var badge = window.ArtworkUpload
            ? window.ArtworkUpload.badgeLabel(state.artworkAnalysis.dpiStatus)
            : "";
          if (badge) {
            artworkStatusRow.hidden = false;
            dpiBadgeEl.hidden = false;
            dpiBadgeEl.textContent = badge;
            dpiBadgeEl.setAttribute("data-status", state.artworkAnalysis.dpiStatus);
            artworkStatusEl.textContent = state.artworkAnalysis.message || "";
          } else if (state.artworkAnalysis.message) {
            artworkStatusRow.hidden = false;
            dpiBadgeEl.hidden = true;
            artworkStatusEl.textContent = state.artworkAnalysis.message;
          } else {
            artworkStatusRow.hidden = true;
          }
        } else if (artworkStatusRow) {
          artworkStatusRow.hidden = true;
        }

        if (dieMsgEl) {
          if (state.artworkAnalysis && state.artworkAnalysis.dieMessage) {
            dieMsgEl.hidden = false;
            dieMsgEl.textContent = state.artworkAnalysis.dieMessage;
            dieMsgEl.classList.toggle("is-found", !!state.artworkAnalysis.dieFound);
          } else {
            dieMsgEl.hidden = true;
            dieMsgEl.textContent = "";
          }
        }

        if (dieToggles) {
          dieToggles.hidden = false;
          dieToggles.querySelectorAll("[data-die-view]").forEach(function (btn) {
            btn.classList.toggle("active", btn.getAttribute("data-die-view") === state.dieView);
          });
          var cBtn = dieToggles.querySelector("[data-die-corners]");
          if (cBtn) {
            cBtn.hidden = !cornersEligible();
            cBtn.classList.toggle("active", cornersOn());
            cBtn.setAttribute("aria-pressed", cornersOn() ? "true" : "false");
          }
        }
        // Resize/rotate always available for artwork (die line stays fixed); contour cut follows the art instead
        if (dieControls) dieControls.hidden = isContour();
        if (dieToggles && isContour()) dieToggles.hidden = true;
        syncDieControls();

        if (uploadProgress) uploadProgress.hidden = true;
      } else {
        fileDrop.hidden = false;
        uploaded.hidden = true;
        uploaded.classList.remove("has-preview", "has-die", "is-soft", "is-good");
        if (artworkStatusRow) artworkStatusRow.hidden = true;
        if (dieMsgEl) dieMsgEl.hidden = true;
        if (dieToggles) dieToggles.hidden = true;
        if (dieControls) dieControls.hidden = true;
      }

      if (state.fileError) {
        fileErrorEl.hidden = false;
        fileErrorEl.textContent = state.fileError;
        fileDrop.classList.add("has-error");
      } else {
        fileErrorEl.hidden = true;
        fileErrorEl.textContent = "";
        fileDrop.classList.remove("has-error");
      }

      if (fileWarningEl) {
        if (state.fileWarning && !state.fileError) {
          fileWarningEl.hidden = false;
          fileWarningEl.textContent = state.fileWarning;
        } else {
          fileWarningEl.hidden = true;
          fileWarningEl.textContent = "";
        }
      }

      var quote = currentQuote();
      var chips = [isContour() ? "Decals" : state.format];
      if (state.format === "Label sheets") chips.push(state.rollShape);
      if (state.format === "Roll labels") {
        chips.push(state.rollShape);
        chips.push(state.rollDirection + " unwind");
      }
      if (cornersOn()) chips.push("Rounded corners");
      var mChip = materialChip(state.material, lamOn());
      if (mChip) chips.push(mChip);
      if (lamOn()) chips.push(state.lamination + " lamination");
      if (state.starterPack) chips.unshift("Starter Pack");
      if (state.stickerPromo) chips.unshift("Sticker promo");
      if (stickerCard) {
        var skOffNow = stickerPromoOff();
        if (skOffNow && state.stickerPromo) { state.stickerPromo = false; state.promoWanted = false; }
        stickerCard.classList.toggle("is-on", !!state.stickerPromo);
        stickerCard.setAttribute("aria-pressed", state.stickerPromo ? "true" : "false");
        stickerCard.hidden = !!designs || skOffNow;
        if (skOffNow) stickerCard.setAttribute("hidden", "");
        var stkFits = stickerSizeOk();
        stickerCard.disabled = skOffNow || !stkFits;
        stickerCard.classList.toggle("is-disabled", skOffNow || !stkFits);
        var stkNote = root.querySelector("[data-sticker-note]");
        if (stkNote) { stkNote.hidden = skOffNow || stkFits || !!designs; if (skOffNow) stkNote.setAttribute("hidden", ""); }
        if (qtySelect) {
          var so = qtySelect.querySelector('option[value="sticker"]');
          if (so) {
            so.disabled = skOffNow || !stkFits;
            so.hidden = skOffNow;
            if (skOffNow) { so.setAttribute("hidden", ""); if (qtySelect.value === "sticker") { qtySelect.value = String(minQty(state.quantity)); state.quantity = minQty(state.quantity); } }
          }
        }
      }
      if (starterCard) {
        starterCard.classList.toggle("is-on", !!state.starterPack);
        starterCard.setAttribute("aria-pressed", state.starterPack ? "true" : "false");
        starterCard.hidden = !!designs;
      }
      chips.push(state.width + " × " + state.height + " " + state.unit);
      if (isContour()) { chips.push(state.contour.offsetMm + " mm cut offset"); chips.push(state.contour.whiteBorder ? "White border" : "No white border"); }
      chips.push(state.quantity.toLocaleString() + " labels" + (designs ? " · " + designs.length + " designs" : ""));
      if (quote.msiRate > 0) chips.push("$" + quote.msiRate.toFixed(2) + " / MSI");
      specEl.innerHTML = chips.map(function (c) { return "<span>" + c + "</span>"; }).join("");

      priceEl.textContent = "$" + quote.price.toFixed(2);
      priceEachEl.textContent = "$" + (quote.price / state.quantity).toFixed(quote.price / state.quantity < 1 ? 3 : 2) + " each" + (quote.msiRate > 0 ? " · $" + quote.msiRate.toFixed(2) + " / MSI" : "");
      renderLamination();
      addBtn.disabled = state.adding;
      if (state.adding) {
        addBtn.innerHTML = "Adding…";
      } else if (state.added) {
        addBtn.innerHTML = "Added to cart ✓";
      } else {
        addBtn.innerHTML = "Add to cart<span>→</span>";
      }
      // Proof-card "Add to cart" mirrors the main button (label, total, disabled state).
      if (proofCartBtn) {
        proofCartBtn.disabled = addBtn.disabled;
        proofCartBtn.classList.toggle("is-busy", !!state.adding);
        if (proofCartLabel) {
          if (state.adding) proofCartLabel.textContent = "Adding…";
          else if (state.added) proofCartLabel.textContent = "Added to cart ✓";
          else proofCartLabel.innerHTML = "Add to cart · <b data-proof-cart-total>$" + quote.price.toFixed(2) + "</b>";
        }
      }
      if (proofCartError) {
        proofCartError.hidden = !state.cartError;
        proofCartError.textContent = state.cartError || "";
      }
      if (cartErrorEl) {
        if (state.cartError) {
          cartErrorEl.hidden = false;
          cartErrorEl.textContent = state.cartError;
        } else {
          cartErrorEl.hidden = true;
          cartErrorEl.textContent = "";
        }
      }
      renderDesigns(quote);
      updateProofArea();
    }

    // Rolls / Sheets segmented choice (radio group: click, Space/Enter, arrow keys, Home/End)
    var formatChoices = Array.prototype.slice.call(root.querySelectorAll("[data-format-choice]"));
    function chooseFormat(f, focus) {
      var nf = normalizeFormat(f);
      if (nf !== state.format) {
        state.format = nf;
        state.added = false;
        state.cartError = "";
        if (state.artwork) resetDieTransform(true);
      }
      if (isContour() && state.artwork) contourAnalyze(state.artwork);
      render();
      if (focus) formatChoices.forEach(function (b) { if (b.getAttribute("data-format-choice") === state.format) b.focus(); });
    }
    formatChoices.forEach(function (btn, idx) {
      btn.addEventListener("click", function () { chooseFormat(btn.getAttribute("data-format-choice"), false); });
      btn.addEventListener("keydown", function (e) {
        var k = e.key, n = formatChoices.length, to = -1;
        if (k === "ArrowRight" || k === "ArrowDown") to = (idx + 1) % n;
        else if (k === "ArrowLeft" || k === "ArrowUp") to = (idx - 1 + n) % n;
        else if (k === "Home") to = 0;
        else if (k === "End") to = n - 1;
        if (to < 0) return;
        e.preventDefault();
        chooseFormat(formatChoices[to].getAttribute("data-format-choice"), true);
      });
    });
    if (formatSelect) {
      formatSelect.addEventListener("change", function () {
        state.format = normalizeFormat(formatSelect.value);
        state.added = false;
        state.cartError = "";
        if (state.artwork) resetDieTransform(true);
        if (isContour() && state.artwork) contourAnalyze(state.artwork);
        render();
      });
    }
    if (materialSelect) {
      materialSelect.addEventListener("change", function () {
        state.material = normalizeMaterial(materialSelect.value);
        state.added = false;
        state.cartError = "";
        render();
      });
    }
    formatBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.format = btn.getAttribute("data-format");
        state.added = false;
        state.cartError = "";
        if (state.artwork) resetDieTransform(true);
        render();
      });
    });
    lamBtns.forEach(function (btn, idx) {
      btn.addEventListener("click", function () { chooseLamination(btn.getAttribute("data-lamination")); });
      btn.addEventListener("keydown", function (e) {
        var k = e.key, n = lamBtns.length, j = -1;
        if (k === "ArrowRight" || k === "ArrowDown") j = (idx + 1) % n;
        else if (k === "ArrowLeft" || k === "ArrowUp") j = (idx - 1 + n) % n;
        else if (k === "Home") j = 0;
        else if (k === "End") j = n - 1;
        if (j < 0) return;
        e.preventDefault();
        chooseLamination(lamBtns[j].getAttribute("data-lamination"));
        lamBtns[j].focus();
      });
    });
    materialBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.material = btn.getAttribute("data-material");
        state.added = false;
        state.cartError = "";
        render();
      });
    });
    rollShapeBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.rollShape = btn.getAttribute("data-roll-shape");
        state.added = false;
        state.cartError = "";
        if (state.artwork) resetDieTransform(true);
        render();
      });
    });
    rollDirBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.rollDirection = btn.getAttribute("data-roll-direction");
        state.added = false;
        state.cartError = "";
        render();
      });
    });
    presetBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var w = Number(btn.getAttribute("data-preset-w"));
        var h = Number(btn.getAttribute("data-preset-h"));
        var m = state.unit === "cm" ? 2.54 : 1;
        state.width = Number((w * m).toFixed(2));
        state.height = Number((h * m).toFixed(2));
        state.added = false;
        state.cartError = "";
        recheckArtworkForSize();
        render();
      });
    });
    widthInput.addEventListener("input", function () {
      var maxW = state.unit === "in" ? 12.2 : 31;
      state.width = Math.min(maxW, Math.max(0.25, Number(widthInput.value) || 0.25));
      if (state.stickerPromo || state.promoWanted) { state.height = state.width; state.promoSide = state.width; }
      state.added = false;
      state.cartError = "";
      recheckArtworkForSize();
      if (isContour()) contourRecut("w");
      render();
    });
    heightInput.addEventListener("input", function () {
      var maxH = state.unit === "in" ? 24 : 60;
      state.height = Math.min(maxH, Math.max(0.25, Number(heightInput.value) || 0.25));
      if (state.stickerPromo || state.promoWanted) { state.width = state.height; state.promoSide = state.height; }
      state.added = false;
      state.cartError = "";
      recheckArtworkForSize();
      if (isContour()) contourRecut("h");
      render();
    });
    unitBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var next = btn.getAttribute("data-unit");
        if (next === state.unit) return;
        var m = next === "cm" ? 2.54 : 1 / 2.54;
        state.width = Number((state.width * m).toFixed(2));
        var maxW = next === "in" ? 12.2 : 31;
        if (state.width > maxW) state.width = maxW;
        state.height = Number((state.height * m).toFixed(2));
        state.unit = next;
        state.added = false;
        state.cartError = "";
        recheckArtworkForSize();
        if (isContour()) contourRecut("w");
        render();
      });
    });
    if (qtySelect) {
      qtySelect.addEventListener("change", function () {
        if (qtySelect.value === "starter") { chooseStarter(); return; }
        if (qtySelect.value === "sticker") { chooseSticker(); return; }
        state.promoWanted = false;
        state.starterPack = false;
        state.stickerPromo = false;
        if (qtySelect.value === "custom") {
          qtyCustomMode = true;
          render();
          if (qtyInput) { qtyInput.focus(); try { qtyInput.select(); } catch (e) { /* ignore */ } }
          return;
        }
        qtyCustomMode = false;
        state.quantity = Number(qtySelect.value) || DEFAULT_QTY;
        state.added = false;
        state.cartError = "";
        render();
      });
    }
    function chooseStarter() { return; // Starter Pack removed 2026-10-26
      if (designs) return; // Starter Pack is single-design only (the dropdown is hidden in multi-design mode anyway)
      state.starterPack = true;
      state.promoWanted = false;
      state.stickerPromo = false;
      state.quantity = STARTER_PACK_QTY;
      qtyCustomMode = false;
      qtyMinShow(false);
      state.added = false;
      state.cartError = "";
      render();
    }
    // Sticker promo: 50 stickers for $19. Stickers = Decals (cut around the artwork) when Decals are switched on; any other type still allowed.
    var STICKER_PROMO_MAX_IN = 5;
    function stickerSizeOk() {
      var k = state.unit === "cm" ? 1 / 2.54 : 1;
      return Number(state.width) * k <= STICKER_PROMO_MAX_IN + 0.005 && Number(state.height) * k <= STICKER_PROMO_MAX_IN + 0.005;
    }
    function stickerPromoOff() { var c = document.documentElement.classList; return c.contains("stickerpromo-off") || c.contains("stickerpromo-noad"); }
    function chooseSticker() {
      if (designs || stickerPromoOff()) { render(); return; }
      if (contourOn() && !isContour()) chooseFormat("Contour cut", false);
      state.stickerPromo = true;
      state.promoWanted = false;
      state.starterPack = false;
      state.quantity = STICKER_PROMO_QTY;
      promoSquare(state.unit === "cm" ? 7.62 : 3);
      qtyCustomMode = false;
      qtyMinShow(false);
      state.added = false;
      state.cartError = "";
      render();
    }
    var stickerCard = root.querySelector("[data-sticker-card]");
    if (stickerCard) stickerCard.addEventListener("click", function () {
      if (state.stickerPromo) return;
      chooseSticker();
    });
    var starterCard = root.querySelector("[data-starter-card]");
    if (starterCard) starterCard.addEventListener("click", function () {
      if (state.starterPack) return;
      chooseStarter();
    });
    var qtyMinNote = root.querySelector("[data-qty-min]");
    function qtyMinShow(on) { if (qtyMinNote) qtyMinNote.hidden = !on; }
    qtyInput.addEventListener("change", function () { // typed below the minimum (not the qty-1 test): bounce to 500 with a short note
      var raw = Math.floor(Number(qtyInput.value) || 0);
      if (raw !== PENNY_TEST_QTY && raw < MIN_ORDER_QTY) { qtyInput.value = MIN_ORDER_QTY; state.quantity = MIN_ORDER_QTY; qtyMinShow(true); render(); }
    });
    qtyInput.addEventListener("input", function () {
      state.promoWanted = false;
      state.starterPack = false;
      state.stickerPromo = false;
      var raw = Math.floor(Number(qtyInput.value) || 0);
      qtyMinShow(raw > 0 && raw !== PENNY_TEST_QTY && raw < MIN_ORDER_QTY);
      try { var __hint = root.querySelector("[data-custom-qty] small"); if (__hint) { if (!__hint.__orig) __hint.__orig = __hint.textContent; __hint.textContent = raw === PENNY_TEST_QTY ? "1 = $0.01 sample" : __hint.__orig; } } catch (e) {}
      state.quantity = Math.min(10000000, minQty(Math.max(1, raw || 1)));
      state.added = false;
        state.cartError = "";
      render();
    });
    qtyBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.quantity = Number(btn.getAttribute("data-qty"));
        state.added = false;
        state.cartError = "";
        render();
      });
    });

    if (contourOffsetInput) {
      contourOffsetInput.addEventListener("input", function () {
        var v = Math.max(1, Math.min(5, Math.round((Number(contourOffsetInput.value) || 1.5) * 2) / 2));
        state.contour.offsetMm = v;
        state.added = false;
        state.cartError = "";
        if (state.contour.id) contourRecut("w");
        render();
      });
    }
    if (contourWhiteInput) {
      contourWhiteInput.addEventListener("change", function () {
        state.contour.whiteBorder = !!contourWhiteInput.checked;
        state.added = false;
        state.cartError = "";
        render();
      });
    }
    fileDrop.addEventListener("click", function () { fileInput.click(); });
    fileDrop.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        fileInput.click();
      }
    });
    fileDrop.addEventListener("dragenter", function (event) {
      event.preventDefault();
      fileDrop.classList.add("is-dragging");
      dropTitle.textContent = "Drop it right here";
    });
    fileDrop.addEventListener("dragover", function (event) { event.preventDefault(); });
    fileDrop.addEventListener("dragleave", function () {
      fileDrop.classList.remove("is-dragging");
      dropTitle.textContent = "Drop artwork or browse";
    });
    fileDrop.addEventListener("drop", function (event) {
      event.preventDefault();
      fileDrop.classList.remove("is-dragging");
      dropTitle.textContent = "Drop artwork or browse";
      selectFile(event.dataTransfer.files && event.dataTransfer.files[0]);
    });
    // "Choose file" inside the proof placeholder + drag-and-drop onto it:
    // reuse the same file input / selectFile() flow as the green drop zone.
    if (proofChooseBtn) {
      proofChooseBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        fileInput.click();
      });
    }
    if (proofCartBtn && addBtn) {
      // Same flow as the main button: clicking it submits the quote form (validation,
      // addToCart(), save-for-revise, redirect to the approval page).
      proofCartBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (addBtn.disabled || proofCartBtn.disabled) return;
        addBtn.click();
      });
    }
    if (proofPlaceholder) {
      var proofDragDepth = 0;
      proofPlaceholder.addEventListener("dragenter", function (event) {
        event.preventDefault();
        event.stopPropagation();
        proofDragDepth++;
        proofPlaceholder.classList.add("is-dragging");
      });
      proofPlaceholder.addEventListener("dragover", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = "copy";
      });
      proofPlaceholder.addEventListener("dragleave", function (event) {
        event.stopPropagation();
        proofDragDepth = Math.max(0, proofDragDepth - 1);
        if (!proofDragDepth) proofPlaceholder.classList.remove("is-dragging");
      });
      proofPlaceholder.addEventListener("drop", function (event) {
        event.preventDefault();
        event.stopPropagation();
        proofDragDepth = 0;
        proofPlaceholder.classList.remove("is-dragging");
        selectFile(event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]);
      });
    }
    fileInput.addEventListener("change", function (event) {
      selectFile(event.target.files && event.target.files[0]);
    });
    fileInput.addEventListener("click", function (event) { event.stopPropagation(); });
    fileRemove.addEventListener("click", function () {
      clearArtwork(false);
      state.added = false;
      state.cartError = "";
      render();
    });

    if (dieToggles) {
      dieToggles.addEventListener("click", function (event) {
        var cb = event.target.closest("[data-die-corners]");
        if (cb) { event.preventDefault(); state.roundedCorners = !state.roundedCorners; render(); return; }
        var btn = event.target.closest("[data-die-view]");
        if (!btn) return;
        event.preventDefault();
        state.dieView = btn.getAttribute("data-die-view") || "both";
        render();
      });
    }

    if (dieRotateInput) {
      dieRotateInput.addEventListener("input", function () {
        var rot = Math.max(-180, Math.min(180, Number(dieRotateInput.value) || 0));
        state.dieTransform = {
          scale: (state.dieTransform && state.dieTransform.scale) || 1,
          rotation: rot,
          offsetX: (state.dieTransform && state.dieTransform.offsetX) || 0,
          offsetY: (state.dieTransform && state.dieTransform.offsetY) || 0
        };
        if (dieRotateVal) dieRotateVal.textContent = Math.round(rot) + "°";
        paintArtworkPreview();
      });
    }
    if (dieResetBtn) {
      dieResetBtn.addEventListener("click", function () {
        state.dieTransform = defaultDieTransform();
        paintArtworkPreview();
        syncDieControls();
      });
    }
    if (dieFitBtn) {
      dieFitBtn.addEventListener("click", function () {
        resetDieTransform(true);
        paintArtworkPreview();
        syncDieControls();
      });
    }

    function sizeLabel() {
      return state.width + " × " + state.height + " " + state.unit;
    }

    function showCartError(message) {
      state.adding = false;
      state.added = false;
      message = __2dErrText(message, "Could not add to cart.");
      state.cartError = (isContour() ? decalCopy(message) : message) || "Could not add to cart.";
      render();
    }

    function updateCartCount(count) {
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = count;
      });
    }

    function resizePreviewDataUrl(source, maxPx, quality) {
      maxPx = maxPx || 1000;
      quality = quality == null ? 0.72 : quality;
      return new Promise(function (resolve) {
        function fail() { resolve(null); }
        try {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          if (!ctx) return fail();

          function draw(w, h, drawFn) {
            if (!w || !h) return fail();
            var scale = Math.min(1, maxPx / Math.max(w, h));
            canvas.width = Math.max(1, Math.round(w * scale));
            canvas.height = Math.max(1, Math.round(h * scale));
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            drawFn(ctx, canvas.width, canvas.height);
            try {
              resolve(canvas.toDataURL("image/jpeg", quality));
            } catch (e) {
              fail();
            }
          }

          if (source && source.tagName === "CANVAS") {
            draw(source.width, source.height, function (c, w, h) {
              c.drawImage(source, 0, 0, w, h);
            });
            return;
          }
          if (typeof source === "string" && source) {
            var img = new Image();
            img.onload = function () {
              draw(img.naturalWidth || img.width, img.naturalHeight || img.height, function (c, w, h) {
                c.drawImage(img, 0, 0, w, h);
              });
            };
            img.onerror = fail;
            img.src = source;
            return;
          }
          if (source && source.tagName === "IMG" && source.src) {
            if (source.complete && source.naturalWidth) {
              draw(source.naturalWidth, source.naturalHeight, function (c, w, h) {
                c.drawImage(source, 0, 0, w, h);
              });
            } else {
              source.addEventListener("load", function () {
                draw(source.naturalWidth, source.naturalHeight, function (c, w, h) {
                  c.drawImage(source, 0, 0, w, h);
                });
              }, { once: true });
              source.addEventListener("error", fail, { once: true });
            }
            return;
          }
          fail();
        } catch (err) {
          fail();
        }
      });
    }

    /** Resize preserving transparency — PNG export for die-only canvases. */
    function resizePngDataUrl(source, maxPx) {
      maxPx = maxPx || 900;
      return new Promise(function (resolve) {
        function fail() { resolve(null); }
        try {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          if (!ctx) return fail();

          function draw(w, h, drawFn) {
            if (!w || !h) return fail();
            var scale = Math.min(1, maxPx / Math.max(w, h));
            canvas.width = Math.max(1, Math.round(w * scale));
            canvas.height = Math.max(1, Math.round(h * scale));
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            drawFn(ctx, canvas.width, canvas.height);
            try {
              resolve(canvas.toDataURL("image/png"));
            } catch (e) {
              fail();
            }
          }

          if (source && source.tagName === "CANVAS") {
            draw(source.width, source.height, function (c, w, h) {
              c.drawImage(source, 0, 0, w, h);
            });
            return;
          }
          if (typeof source === "string" && source) {
            var img = new Image();
            img.onload = function () {
              draw(img.naturalWidth || img.width, img.naturalHeight || img.height, function (c, w, h) {
                c.drawImage(img, 0, 0, w, h);
              });
            };
            img.onerror = fail;
            img.src = source;
            return;
          }
          fail();
        } catch (err) {
          fail();
        }
      });
    }

    function strokeRoundedRect(ctx, x, y, w, h, r) {
      r = Math.max(0, Math.min(r, Math.min(w, h) / 2));
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    /** Magenta dotted cut path PNG for on-screen preview only. Production dieline is server PDF with layer CUT PATH. */
    function generateDieOnlyDataUrl(shape, widthIn, heightIn, maxPx) {
      maxPx = maxPx || 900;
      return new Promise(function (resolve) {
        try {
          var wIn = Math.max(0.25, Number(widthIn) || 2);
          var hIn = Math.max(0.25, Number(heightIn) || 2);
          var pxPerIn = Math.min(maxPx / wIn, maxPx / hIn);
          var w = Math.max(32, Math.round(wIn * pxPerIn));
          var h = Math.max(32, Math.round(hIn * pxPerIn));
          var canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext("2d");
          if (!ctx) return resolve(null);
          ctx.clearRect(0, 0, w, h);
          var inset = Math.max(3, Math.round(Math.min(w, h) * 0.02));
          var strokeW = Math.max(2, Math.round(Math.min(w, h) * 0.01));
          var x = inset;
          var y = inset;
          var rw = w - inset * 2;
          var rh = h - inset * 2;
          var s = String(shape || "rectangle").toLowerCase();
          ctx.strokeStyle = (window.ArtworkUpload && window.ArtworkUpload.DIE_MAGENTA) || "#ff00aa";
          ctx.lineWidth = strokeW;
          ctx.setLineDash([strokeW * 3.5, strokeW * 2.2]);
          ctx.lineJoin = "round";
          ctx.lineCap = "round";
          ctx.beginPath();
          if (s === "round" || s === "circle" || s === "oval") {
            ctx.ellipse(w / 2, h / 2, rw / 2, rh / 2, 0, 0, Math.PI * 2);
          } else if (s === "rounded" || s === "kiss") {
            strokeRoundedRect(ctx, x, y, rw, rh, Math.min(rw, rh) * 0.14);
          } else if (s === "diecut") {
            strokeRoundedRect(ctx, x, y, rw, rh, Math.min(rw * 0.08, rh * 0.12));
          } else if (s === "square" || s === "rectangle") {
            strokeRoundedRect(ctx, x, y, rw, rh, 2);
          } else {
            strokeRoundedRect(ctx, x, y, rw, rh, 2);
          }
          ctx.stroke();
          resolve(canvas.toDataURL("image/png"));
        } catch (e) {
          resolve(null);
        }
      });
    }

    /** Art only — no die overlay. */
    function captureArtworkDataUrl() {
      if (state.artworkAnalysis && state.artworkAnalysis.artworkCanvas) {
        return resizePreviewDataUrl(state.artworkAnalysis.artworkCanvas);
      }
      if (previewEl) {
        var liveCanvas = previewEl.querySelector("canvas.artwork-layer-art");
        if (liveCanvas && liveCanvas.width) return resizePreviewDataUrl(liveCanvas);
        var liveImg = previewEl.querySelector("img.artwork-layer-art");
        if (liveImg && liveImg.src) return resizePreviewDataUrl(liveImg);
      }
      if (state.artworkAnalysis && state.artworkAnalysis.previewUrl) {
        return resizePreviewDataUrl(state.artworkAnalysis.previewUrl);
      }
      if (state.previewUrl) return resizePreviewDataUrl(state.previewUrl);
      return Promise.resolve(null);
    }

    /** Die overlay for customer preview only (PNG). Approve flow builds CUT PATH PDF server-side. */
    function captureDieDataUrl() {
      if (state.artworkAnalysis && state.artworkAnalysis.dieCanvas) {
        return resizePngDataUrl(state.artworkAnalysis.dieCanvas, 900);
      }
      if (previewEl) {
        var dieCanvas = previewEl.querySelector("canvas.artwork-layer-die");
        if (dieCanvas && dieCanvas.width) return resizePngDataUrl(dieCanvas, 900);
      }
      var inches = toInches();
      return generateDieOnlyDataUrl(previewShape(), inches.widthIn, inches.heightIn, 900);
    }

    /**
     * Combined customer preview (art + die) for receipt thumbnail.
     * Falls back to art-only when compositing is unavailable.
     */
    function captureApprovalPreview(artworkDataUrl, dieDataUrl) {
      if (artworkDataUrl && dieDataUrl) {
        return new Promise(function (resolve) {
          var artImg = new Image();
          var dieImg = new Image();
          var pending = 2;
          var failed = false;
          function done() {
            if (failed) {
              resolve(artworkDataUrl);
              return;
            }
            try {
              var w = artImg.naturalWidth || artImg.width || 1;
              var h = artImg.naturalHeight || artImg.height || 1;
              var maxPx = 1000;
              var scale = Math.min(1, maxPx / Math.max(w, h));
              var tw = Math.max(1, Math.round(w * scale));
              var th = Math.max(1, Math.round(h * scale));
              var canvas = document.createElement("canvas");
              canvas.width = tw;
              canvas.height = th;
              var ctx = canvas.getContext("2d");
              if (!ctx) {
                resolve(artworkDataUrl);
                return;
              }
              ctx.fillStyle = "#ffffff";
              ctx.fillRect(0, 0, tw, th);
              ctx.drawImage(artImg, 0, 0, tw, th);
              ctx.drawImage(dieImg, 0, 0, tw, th);
              resolve(canvas.toDataURL("image/jpeg", 0.72));
            } catch (e) {
              resolve(artworkDataUrl);
            }
          }
          function tick() {
            pending -= 1;
            if (pending <= 0) done();
          }
          artImg.onload = tick;
          dieImg.onload = tick;
          artImg.onerror = function () { failed = true; tick(); };
          dieImg.onerror = function () { failed = true; tick(); };
          artImg.src = artworkDataUrl;
          dieImg.src = dieDataUrl;
        });
      }
      if (artworkDataUrl) return Promise.resolve(artworkDataUrl);
      // Legacy fallback — art layer / analysis
      if (previewEl) {
        var liveCanvas = previewEl.querySelector("canvas.artwork-layer-art") || previewEl.querySelector("canvas");
        if (liveCanvas && liveCanvas.width) return resizePreviewDataUrl(liveCanvas);
        var liveImg = previewEl.querySelector("img.artwork-layer-art") || previewEl.querySelector("img");
        if (liveImg && liveImg.src) return resizePreviewDataUrl(liveImg);
      }
      if (state.artworkAnalysis) {
        if (state.artworkAnalysis.artworkCanvas) {
          return resizePreviewDataUrl(state.artworkAnalysis.artworkCanvas);
        }
        if (state.artworkAnalysis.previewUrl) {
          return resizePreviewDataUrl(state.artworkAnalysis.previewUrl);
        }
      }
      if (state.previewUrl) return resizePreviewDataUrl(state.previewUrl);
      return Promise.resolve(null);
    }

    function buildApprovalPayload(quote, previewDataUrl, artworkDataUrl, dieDataUrl) {
      var specs = {
        format: state.format,
        material: materialLabel(state.material),
        size: sizeLabel(),
        qty: String(state.quantity) + " labels"
      };
      if (state.format === "Label sheets") specs.shape = state.rollShape;
      if (cornersOn()) specs.corners = cornersProp() + " corners";
      if (lamOn()) specs.lamination = state.lamination + " lamination";
      if (state.starterPack) specs.starterPack = "Starter Pack · 100 labels";
      if (state.stickerPromo) specs.starterPack = "Sticker promo · 50 stickers";
      if (state.format === "Roll labels") {
        specs.rollShape = state.rollShape;
        specs.unwind = state.rollDirection + " unwind";
      }
      if (isContour()) {
        specs.format = "Decals";
        specs.shape = "Cut around artwork · " + state.contour.offsetMm + " mm offset" + (state.contour.whiteBorder ? " · white border" : "");
      }
      var inches = toInches();
      var payload = {
        fileName: state.artwork ? state.artwork.name : "To be sent after ordering",
        checkLabel: state.artworkAnalysis && state.artworkAnalysis.checkLabel
          ? state.artworkAnalysis.checkLabel
          : (state.artwork ? "Uploaded" : "None"),
        specs: specs,
        quotedPrice: quote.price,
        shape: previewShape(),
        widthIn: inches.widthIn,
        heightIn: inches.heightIn,
        sizeLabel: sizeLabelForPreview(inches),
        dieTransform: state.artwork && state.dieTransform ? state.dieTransform : { scale: 1, rotation: 0, offsetX: 0, offsetY: 0 },
        dieView: state.artwork ? state.dieView : "both",
        corners: cornersOn() ? cornersProp() : undefined,
        cornerRadiusIn: cornersOn() ? CORNER_RADIUS_IN : 0
      };
      if (isContour()) {
        payload.shape = "contour";
        payload.contour = { id: state.contour.id, offsetMm: state.contour.offsetMm, whiteBorder: state.contour.whiteBorder, previewToken: window.__contourPreviewToken || "", cutIn: state.contour.cut ? state.contour.cut.cutIn : null };
        payload.quantity = state.quantity;
      }
      if (previewDataUrl) payload.previewDataUrl = previewDataUrl;
      if (artworkDataUrl) payload.artworkDataUrl = artworkDataUrl;
      if (dieDataUrl) payload.dieDataUrl = dieDataUrl;
      payload.itemKey = window.__2dLastItemKey || "";
      payload.designGroup = window.__2dLastGroup || "";
      return payload;
    }

    function tryStashPayload(payload) {
      try {
        sessionStorage.setItem("2day_artwork_approval", JSON.stringify(payload));
        return true;
      } catch (err) {
        return false;
      }
    }

    function stashApprovalAndGo(quote) {
      var approveUrl = (window.themeCart && window.themeCart.approveUrl) || "/pages/approve-artwork";
      var shotsReady = isContour()
        ? contourCompositeDataUrl().then(function (comp) {
            return { artworkDataUrl: state.contour.artPreview || null, dieDataUrl: null, previewDataUrl: comp || state.contour.artPreview || null };
          })
        : Promise.all([captureArtworkDataUrl(), captureDieDataUrl()])
        .then(function (pair) {
          var artworkDataUrl = pair[0] || null;
          var dieDataUrl = pair[1] || null;
          return captureApprovalPreview(artworkDataUrl, dieDataUrl).then(function (previewDataUrl) {
            return { artworkDataUrl: artworkDataUrl, dieDataUrl: dieDataUrl, previewDataUrl: previewDataUrl };
          });
        });
      return shotsReady
        .then(function (shots) {
          var payload = buildApprovalPayload(
            quote,
            shots.previewDataUrl,
            shots.artworkDataUrl,
            shots.dieDataUrl
          );
          // Prefer artwork + die over huge combined preview when quota is tight
          if (!tryStashPayload(payload)) {
            var prefer = Object.assign({}, payload);
            delete prefer.previewDataUrl;
            if (!tryStashPayload(prefer)) {
              var artOnly = Object.assign({}, prefer);
              delete artOnly.dieDataUrl;
              if (!tryStashPayload(artOnly)) {
                var dieOnly = Object.assign({}, prefer);
                delete dieOnly.artworkDataUrl;
                if (!tryStashPayload(dieOnly)) {
                  var bare = Object.assign({}, payload);
                  delete bare.previewDataUrl;
                  delete bare.artworkDataUrl;
                  delete bare.dieDataUrl;
                  tryStashPayload(bare);
                }
              }
            }
          }
          var restore = {
            v: 1,
            ts: Date.now(),
            path: window.location.pathname,
            format: state.format,
            material: materialLabel(state.material),
            rollShape: state.rollShape,
            lamination: state.lamination,
            starterPack: !!state.starterPack,
            stickerPromo: !!state.stickerPromo,
            rollDirection: state.rollDirection,
            width: promoSendW(),
            height: promoSendH(),
            unit: state.unit,
            quantity: state.quantity,
            hasArtwork: !!state.artwork,
            fileName: state.artwork ? state.artwork.name : "",
            dieTransform: state.artwork ? state.dieTransform : null,
            dieView: state.artwork ? state.dieView : "both",
            contourOffsetMm: state.contour.offsetMm,
            contourWhiteBorder: state.contour.whiteBorder
          };
          return saveQuoteRestore(restore, state.artwork || null).then(function () {
            window.location.href = approveUrl;
          });
        });
    }

    function addToCart() {
      if (state.adding) return;
      if (designs) { addDesignsToCart(); return; }
      if (isContour()) {
        var why = contourBlockReason();
        if (why) { showCartError(why); return; }
      }
      var config = window.themeCart || {};
      var cartUrl = config.cartUrl || "/cart";
      var addUrl = config.addUrl || "/cart/add.js";
      var cartJsUrl = config.cartJsUrl || "/cart.js";
      var clearUrl = config.clearUrl || "/cart/clear.js";
      var quoteVariantUrl =
        config.quoteVariantUrl || "https://2daylabels.com/apps/artwork-upload/quote-variant";
      var uploadSecret = config.uploadSecret || "";

      state.adding = true;
      state.added = false;
      state.cartError = "";
      render();

      // The API prices the order from the selections alone (client price is only
      // sent for mismatch logging) and returns the variant + server total.
      var quote = currentQuote();
      var labelQty = Math.max(1, Math.round(Number(state.quantity) || 1));

      var properties = {
        Format: state.format,
        Material: materialLabel(state.material),
        Size: sizeLabel(),
        Quantity: String(labelQty) + " labels",
        "Label quantity": String(labelQty),
        "Artwork filename": state.artwork ? state.artwork.name : "To be sent after ordering",
        "Artwork check": state.artworkAnalysis && state.artworkAnalysis.checkLabel
          ? state.artworkAnalysis.checkLabel
          : (state.artwork ? "Uploaded" : "None"),
        "Estimated total": "$" + quote.price.toFixed(2),
        _quoted_price: quote.price.toFixed(2),
        _price_mode: "unit"
      };
      if (state.format === "Label sheets") properties.Shape = state.rollShape;
      if (state.format === "Roll labels") {
        properties["Roll shape"] = state.rollShape;
        properties.Unwind = state.rollDirection + " unwind";
      }
      if (cornersOn()) properties.Corners = cornersProp();
      if (lamOn()) properties.Lamination = state.lamination;
      if (state.starterPack) properties["Starter Pack"] = "100 labels";
      if (state.stickerPromo) properties["Sticker Promo"] = "50 stickers";
      if (isContour()) {
        properties.Shape = "Decal (cut around artwork)";
        properties["Cut offset"] = state.contour.offsetMm + " mm";
        properties["White border"] = state.contour.whiteBorder ? "Yes" : "No";
        properties._contour_id = state.contour.id;
        properties._contour_offset_mm = String(state.contour.offsetMm);
        properties._contour_white_border = state.contour.whiteBorder ? "1" : "0";
      } else if (state.artwork && state.dieTransform) {
        var dt = state.dieTransform;
        properties["Artwork transform"] =
          "scale " + (Math.round((dt.scale || 1) * 100) / 100) +
          " / rot " + Math.round(dt.rotation || 0) + "°";
      }

      function parseJsonResponse(res) {
        return res.text().then(function (text) {
          var data = {};
          try {
            data = text ? JSON.parse(text) : {};
          } catch (err) {
            data = { description: text };
          }
          if (!res.ok || (data.status && Number(data.status) >= 400)) {
            throw new Error(__2dErrText(data, "Could not add to cart."));
          }
          return data;
        });
      }

      function createQuoteVariant() {
        if (!uploadSecret) {
          return Promise.reject(new Error("Missing upload secret for quote variant API."));
        }
        return __2dApiFetch(quoteVariantUrl, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-2Day-Secret": uploadSecret
          },
          body: JSON.stringify({
            secret: uploadSecret,
            format: state.format,
            material: state.material,
            width: promoSendW(),
            height: promoSendH(),
            unit: state.unit,
            quantity: labelQty,
            rollShape: state.format === "Roll labels" || state.format === "Label sheets" ? state.rollShape : undefined,
            lamination: lamOn() ? state.lamination : undefined,
            corners: cornersOn() ? cornersProp() : undefined,
            starterPack: state.starterPack && !designs ? true : undefined,
            stickerPromo: state.stickerPromo && !designs ? true : undefined,
            rollDirection: state.format === "Roll labels" ? state.rollDirection : undefined,
            contourPreview: isContour() ? (window.__contourPreviewToken || undefined) : undefined,
            contourId: isContour() ? state.contour.id : undefined,
            contourOffsetMm: isContour() ? state.contour.offsetMm : undefined,
            contourWhiteBorder: isContour() ? state.contour.whiteBorder : undefined,
            clientTotal: quote.price
          })
        }).then(function (res) {
          return res.text().then(function (text) {
            var data = {};
            try {
              data = text ? JSON.parse(text) : {};
            } catch (err) {
              data = { error: text };
            }
            if (!res.ok || !data.ok || !data.variantId) {
              throw new Error(__2dErrText(data, "Could not create quote price."));
            }
            return data;
          });
        });
      }

      __2dOriginalsWithin([state.artwork], uploadSecret, 45000)
        .then(function (origs) {
          if (origs && origs[0]) { properties["Original file"] = origs[0]; properties._original_url = origs[0]; }
          return createQuoteVariant();
        })
        .then(function (variantInfo) {
          // Server price is authoritative for everything shown from here on.
          var serverTotal = Number(variantInfo.total);
          if (isFinite(serverTotal) && serverTotal > 0) {
            serverQuote = {
              key: selectionKey(),
              price: serverTotal,
              msiRate: Number(variantInfo.msiRate) || quote.msiRate
            };
            quote = { price: serverTotal, msiRate: serverQuote.msiRate };
          }
          properties["Estimated total"] = "$" + quote.price.toFixed(2);
          properties._quoted_price = quote.price.toFixed(2);
          properties._price_mode = variantInfo.priceMode || "pack";
          properties._unit_price = variantInfo.unitPrice;
          properties._line_total = variantInfo.lineTotal;
          if (variantInfo.roundingDiffCents) {
            properties._rounding_diff_cents = String(variantInfo.roundingDiffCents);
          }
          var itemKey = Math.random().toString(16).slice(2, 10);
          properties._item_key = itemKey;
          window.__2dLastItemKey = itemKey; window.__2dLastGroup = "";
          return Promise.resolve().then(function () { // multi-item cart: add, never clear
            return fetch(addUrl, {
              method: "POST",
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: JSON.stringify({
                id: variantInfo.variantId,
                quantity: Number(variantInfo.cartQuantity) || 1,
                properties: properties
              })
            }).then(parseJsonResponse);
          });
        })
        .then(function () {
          return fetch(cartJsUrl, {
            credentials: "same-origin",
            headers: { Accept: "application/json" }
          }).then(function (res) {
            return res.json();
          });
        })
        .then(function (cart) {
          // Cart badge: one custom order line (not label count)
          updateCartCount(cart && cart.items ? cart.items.length : 1);
          if (false) {
            var hasQuote = cart.items.some(function (item) {
              var props = item.properties || {};
              return props._quoted_price || props["Estimated total"];
            });
            if (!hasQuote && typeof cart.item_count !== "undefined") {
              updateCartCount(cart.item_count);
            }
          }
          state.adding = false;
          state.added = true;
          render();
          // Artwork approval page (summary + approve + email + pay)
          stashApprovalAndGo(quote).catch(function () {
            window.location.href = (config.approveUrl || "/pages/approve-artwork");
          });
        })
        .catch(function (err) {
          showCartError(err && err.message ? err.message : "Could not add to cart.");
        });
    }

    root.addEventListener("submit", function (event) {
      event.preventDefault();
      addToCart();
    });

    function applyQuoteRestore(force) {
      if (quoteRestoreUsed) return false;
      var revise = isReviseVisit();
      var saved = readQuoteRestore();
      if (!force && !revise) {
        // Back navigation restores only the quote saved from this same page.
        if (!isBackNavigation() || !saved || saved.path !== window.location.pathname) return false;
      }
      quoteRestoreUsed = true;
      removeRestorePill();
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete("revise");
        window.history.replaceState(null, "", url.pathname + url.search + url.hash);
      } catch (e) { /* ignore */ }
      if (!saved) return false;
      ["format", "material", "rollShape", "rollDirection", "unit"].forEach(function (k) {
        if (typeof saved[k] === "string" && saved[k]) state[k] = saved[k];
      });
      state.lamination = LAMINATIONS.indexOf(saved.lamination) !== -1 ? saved.lamination : "None";
      if (saved.format === CONTOUR_FORMAT && !contourOn()) pendingContour = true;
      state.format = normalizeFormat(state.format);
      state.material = normalizeMaterial(state.material);
      if (Number(saved.contourOffsetMm) >= 1) state.contour.offsetMm = Math.min(5, Number(saved.contourOffsetMm));
      if (saved.contourWhiteBorder === false) state.contour.whiteBorder = false;
      ["width", "height", "quantity"].forEach(function (k) {
        var n = Number(saved[k]);
        if (isFinite(n) && n > 0) state[k] = n;
      });
      state.starterPack = false && saved.starterPack === true && Number(state.quantity) === STARTER_PACK_QTY && !(Array.isArray(saved.designs) && saved.designs.length >= 2);
      state.stickerPromo = !state.starterPack && saved.stickerPromo === true && Number(state.quantity) === STICKER_PROMO_QTY && !(Array.isArray(saved.designs) && saved.designs.length >= 2);
      if (!state.starterPack && !state.stickerPromo) state.quantity = minQty(state.quantity);
      state.added = false;
      if (Array.isArray(saved.designs) && saved.designs.length >= 2 && !isContour()) {
        designs = saved.designs.slice(0, MAX_DESIGNS).map(function (sd) { return blankDesign(Math.max(MIN_DESIGN_QTY, Math.floor(Number(sd && sd.qty) || 0))); });
        activeDesign = 0;
        designsPanelSig = "";
        syncDesignQty();
        saved.designs.forEach(function (sd, i) {
          if (i === 0 || !sd || !sd.hasArtwork || !designs[i]) return;
          idbFile("readonly", null, "artwork-" + (i + 1)).then(function (rec) {
            if (!rec || (!rec.file && !rec.buf)) return;
            var f = rec.file || new Blob([rec.buf], { type: rec.type || "" });
            if (!(f instanceof File) && window.File) {
              try { f = new File([f], rec.name || sd.fileName || "artwork", { type: rec.type || f.type, lastModified: rec.lastModified || Date.now() }); } catch (e) { /* keep blob */ }
            }
            analyzeIntoDesign(i, f, { dieTransform: sd.dieTransform, dieView: sd.dieView });
          }).catch(function () { /* customer can re-upload */ });
        });
      }
      if (saved.hasArtwork) {
        idbFile("readonly")
          .then(function (rec) {
            if (!rec || (!rec.file && !rec.buf)) return;
            var file = rec.file || new Blob([rec.buf], { type: rec.type || "" });
            if (!(file instanceof File) && window.File) {
              try { file = new File([file], rec.name || saved.fileName || "artwork", { type: rec.type || file.type, lastModified: rec.lastModified || Date.now() }); } catch (e) { /* keep blob */ }
            }
            pendingRestore = { dieTransform: saved.dieTransform, dieView: saved.dieView };
            selectFile(file);
            // Keep the transform when selectFile() finishes without analysis.
            if (state.artwork && pendingRestore) {
              if (pendingRestore.dieTransform) state.dieTransform = Object.assign({}, state.dieTransform, pendingRestore.dieTransform);
              pendingRestore = null;
              render();
            }
          })
          .catch(function () { /* artwork not available — customer can re-upload */ });
      }
      var scrollToQuote = function () {
        var target = qbScope && qbScope.getBoundingClientRect ? qbScope : root;
        var top = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 12;
        window.scrollTo(0, Math.max(0, top));
      };
      setTimeout(scrollToQuote, 60);
      window.addEventListener("load", function () { setTimeout(scrollToQuote, 60); });
      return true;
    }
    function removeRestorePill() {
      var pill = root.querySelector("[data-qb-restore-pill]");
      if (pill && pill.parentNode) pill.parentNode.removeChild(pill);
    }
    // Fresh visit with a saved (unexpired) quote from this page: offer a one-tap restore.
    function offerRestorePill() {
      var saved = readQuoteRestore();
      if (!saved || saved.path !== window.location.pathname || root.querySelector("[data-qb-restore-pill]")) return;
      var pill = document.createElement("button");
      pill.type = "button";
      pill.className = "qb-restore-pill";
      pill.setAttribute("data-qb-restore-pill", "");
      pill.innerHTML = '<span aria-hidden="true">↺</span> Restore your last quote';
      pill.addEventListener("click", function () {
        quoteRestoreUsed = false;
        if (applyQuoteRestore(true)) render();
      });
      root.insertBefore(pill, root.firstChild);
    }

    var restoredQuote = applyQuoteRestore(false);
    if (!restoredQuote) offerRestorePill();

    // bfcache return (Safari swipe-back / back button): the page comes back exactly as it was,
    // selections and artwork included; just clear the "adding / added" button state.
    window.addEventListener("pageshow", function (event) {
      if (!event.persisted) return;
      state.adding = false;
      state.added = false;
      if (!state.artwork && !quoteRestoreUsed) {
        var saved = readQuoteRestore();
        if (saved && saved.path === window.location.pathname) { quoteRestoreUsed = false; applyQuoteRestore(true); }
      }
      render();
    });

    document.addEventListener("twoday:quote-config", function () { render(); });
    window.addEventListener("contour-on", function () {
      if (pendingContour) { pendingContour = false; state.format = CONTOUR_FORMAT; state.added = false; if (state.artwork) contourAnalyze(state.artwork); }
      render();
    });
    window.addEventListener("contour-off", function () { if (isContour()) { state.format = "Roll labels"; state.added = false; } render(); });
    window.addEventListener("diecut-off", function () { var nf = normalizeFormat(state.format); if (nf !== state.format) { state.format = nf; state.added = false; render(); } });
    render();

    // Per-type pages force their label type on load — unless we just restored a revised quote.
    var orderSource = restoredQuote ? null : document.querySelector("[data-order-format]");
    if (orderSource) {
      var orderFormat = orderSource.getAttribute("data-order-format");
      var orderMaterial = orderSource.getAttribute("data-order-material");
      var orderRollShape = orderSource.getAttribute("data-order-roll-shape");
      // Removed types (Round/Rectangle/Square/Oval) map to Die-cut; finishes preselect in the drop-down.
      if (orderFormat) state.format = normalizeFormat(orderFormat);
      if (orderMaterial) state.material = normalizeMaterial(orderMaterial);
      render();
      var orderShapeBtn = orderRollShape && root.querySelector('[data-roll-shape="' + orderRollShape + '"]');
      if (orderShapeBtn) orderShapeBtn.click();
    }
    // Size presets: page attributes (size landing pages) first, then URL parameters (deep links) on top. Skipped after a restored quote.
    if (!restoredQuote) {
      var sizePreset = Object.assign({}, readAttrPreset(orderSource), readUrlPreset());
      if (Object.keys(sizePreset).length) {
        if (sizePreset.format === CONTOUR_FORMAT && !contourOn()) pendingContour = true;
        if (sizePreset.format) state.format = normalizeFormat(sizePreset.format);
        if (sizePreset.material) state.material = normalizeMaterial(sizePreset.material);
        if (sizePreset.rollShape) state.rollShape = sizePreset.rollShape;
        if (sizePreset.width && sizePreset.height) { state.unit = sizePreset.unit || "in"; state.width = sizePreset.width; state.height = sizePreset.height; }
        if (sizePreset.quantity) { state.quantity = sizePreset.quantity; qtyCustomMode = !qtyInList(state.quantity); }
        state.added = false;
        render();
      }
      // ?promo=stickers (homepage sticker-promo banner / links): preselect only when the promo flag is on
      if (!stickerPromoOff() && /^stickers?$/i.test(new URLSearchParams(window.location.search).get("promo") || "")) chooseSticker();
      if (stickerPromoOff() && state.stickerPromo) { state.stickerPromo = false; state.promoWanted = false; state.quantity = minQty(state.quantity); }
    }
    window.addEventListener("stickerpromo-off", function () {
      if (state.stickerPromo || state.promoWanted) {
        state.stickerPromo = false;
        state.promoWanted = false;
        if (!state.starterPack) state.quantity = minQty(state.quantity);
        qtyCustomMode = false;
        state.added = false;
      }
      render();
    });
    root.addEventListener("qb-select-sticker-promo", function () { chooseSticker(); });
  }

  function boot() {
    document.querySelectorAll("[data-quote-builder]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
